import { Injectable } from '@angular/core';
import {
  CONTRACTS_LIST,
  ERROR_102,
  ERROR_103,
  ERROR_104,
  ERROR_105,
  ERROR_107,
  ERROR_108,
  ERROR_111,
  ERROR_112,
  ERROR_113,
  ERROR_121,
  ERROR_122,
  ERROR_123,
  ERROR_124,
  ERROR_125,
  ERROR_126,
  ERROR_127,
  ERROR_128,
  ERROR_129,
  ERROR_130,
  ERROR_400,
  ERROR_131,
  ERROR_132,
  ERROR_133,
  ERROR_135,
  ERROR_137,
  ERROR_140,
  ERROR_141,
  ERROR_401,
  ERROR_402,
  ERROR_403,
  ERROR_404,
  ERROR_500,
  ERROR_501,
  ERROR_502,
  ERROR_512,
  ERROR_514,
  ERROR_602,
  ERROR_BRANCH,
  ERROR_DBS,
  ERROR_NONE,
  ERROR_TECH,
  ERROR_LIB,
  ERROR_142,
  ERROR_134,
  ERROR_138,
  ERROR_136,
  ERROR_139,
  ERROR_143,
  ERROR_999,
  ERROR_0104,

} from '../../constants/abre-cuentas.constants';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { OpEnum } from '../../enums/op.enum';
import {
  AbreCuentasModel,
  AccountSelectionModel,
  AgencyModel,
  BasicInfoSecondHeadlineModel,
  BioCatchConfigModel,
  CardTypeModel,
  CiiuModel,
  CiiuSecondModel,
  CityModel,
  CityModelAlt,
  ConfigValuesModel,
  ContactSecondHeadlineModel,
  DetailAccountModel,
  DetailRevolvingCreditModel,
  EmployedContractModel,
  EmployedContractSecondHeadlineModel,
  FinancialModel,
  ForeignCurrencyModel,
  ForeignProductsModel,
  IncomesOriginModel,
  IncomesOriginSecondHeadlineModel,
  LottieImage,
  MaritalStatusModel,
  MaritalStatusSecondHeadlineModel,
  OfficeModel,
  OfficeSecondHeadlineModel,
  OtherFinancialModel,
  OtherFinancialSecondHeadlineModel,
  PayDayProductModel,
  PcoModel,
  ProductCard,
  SecondHeadlineModel,
  SimulatorModel,
  LoanModel,
  TypeContractModel,
  VirtualCardFranchiseModel,
  CountryModel,
  EthnicGroupModel,
} from '../../models/abre-cuentas.model';
import {
  AgreementsModel,
  DetailAgreement,
} from '../../models/agreements.model';
import { AppInfoModel } from '../../models/app-info.model';
import { IBasciModel } from '../../models/basicModel/basic.model';
import {
  BytteConfigType,
  CheckboxModel,
  DSBMobileConfig,
} from '../../models/common.model';
import { AddressModel, ContactModel } from '../../models/contact.model';
import { DeviceInfoModel } from '../../models/device-info.model';
import { DocumentModel } from '../../models/document.model';
import { ErrorModel } from '../../models/error.model';
import { FiModel } from '../../models/fi.model';
import {
  LiveAbroadModel,
  ObjectCheckModel,
} from '../../models/live-abroad.model';
import { LogDeviceModel } from '../../models/log-device.model';
import { PhotosModel } from '../../models/photos.model';
import { CopyService } from '../copies/copy.service';
import { HelpersService } from '../helpers/helpers-onboarding.service';
import { LoadingService } from '../loading/loading.service';
import {
  ERROR_600,
  ERROR_601,
  ERROR_603,
} from './../../constants/abre-cuentas.constants';
import { CHANNEL } from 'src/app/shared/constants/channel.constants';
import { ParametersService } from '../parameters/parameters.service';
import { HttpHeaders } from '@angular/common/http';
import { IRescueData } from '../../interfaces/rescue-data.interface';
import { TransactionInfoModel } from '../../models/transaction.model';

@Injectable()

/**
 * Funciones globales para usar a lo largo de la aplicación
 *
 * Global functions to use along the app
 *
 * @type {class}
 */
export class AbreCuentasService {
  chanelid: string;
  code_ally: string;
  flagGreyZone: boolean;
  rate_ally;
  code: string;
  /**
   * Contiene los productos seleccionados en la pantalla de vinculación
   */
  productsSelectVicul: string[] = [];
  isInsurability: boolean;
  parametrizedHeaders: HttpHeaders | undefined = undefined;
  dataTagg: any;

  private isNewClient: boolean;
  userJemelii = false;

  constructor(
    private copiesService: CopyService,
    private loadingService: LoadingService,
    private helperService: HelpersService,
    private parametersService: ParametersService,
  ) {
    if (!this.abreCuentasModel) {
      this.abreCuentasModel = new AbreCuentasModel();
    }
  }
  /**
   *
   *
   * *
   *
   *
   */
  private intentos = 0;
  private validationOtp = 0;
  typeProduct;
  /**
   * Trae el contexto de AbreCuentasModel en abreCuentasModel
   *
   * *Bring AbreCuentasModel context to this class*
   *
   * @access              private
   * @type                {AbreCuentasModel}
   */
  private abreCuentasModel: AbreCuentasModel;
  /**
   * Usar registerBytteLicensePromise cómo una promesa
   *
   * *Use registerBytteLicensePromise as promise*
   *
   * @access              private
   * @type                {Promise<any>}
   */
  private registerBytteLicensePromise: Promise<any>;
  /**
   * Inicialización de devicePermission en vacio
   *
   * *Setting up devicePermissiones as null*
   *
   * @access              private
   * @type                {string}
   */
  private devicePermissions = '';
  /**
   * Inicialización de geoLocalization como string
   *
   * *Setting up geoLocalization as string*
   *
   * @access              private
   * @type                {string}
   */
  private geoLocalization: string;

  /**
   * Inicialización de consulta
   * *Setting up request*
   *
   * @access              private
   * @type                {any}
   */
  private requestModel: any;

  /**
   * Inicialización de consulta
   * *Setting up request*
   *
   * @access              private
   * @type                {any}
   */
  private customerRequests: any;

  /**
   * Inicialización de documento subido
   * *Setting up request*
   *
   * @access              private
   * @type                {boolean}
   */
  private documentsUploaded = false;
  /**
   * Instancia de errorInfo como ErroeModel
   *
   * *Instance of errorInfo as ErrorModel*
   *
   * @access              private
   * @type                {string}
   */
  errorInfo = new ErrorModel();
  savevaluemodel: any;
  contractTypemodel: any;
  DisbursementConfiguration: any;
  requestLoanSelected: any;
  inputTermAmount;
  pep = 'No';

  /**
   * Summary      Constructor of the component.
   * @param       {LoadingService}            loadingService              Injectable loadingService service.
   * @param       {HelperService}             helperService               Injectable helperService service.
   */

  /**
   * productos seleecionados flujo multi-producto
   */
  productSelect: any[] = [];

  /**
   * Tipo de libranza seleccionada
   */
  productDestinationType: string | undefined;

  /**
   * productos consultados flujo multi-producto
   */
  maxproducts: any[] = [];

  /**
   * Seleccion de credito
   */
  creditSelection: any;

  /**
   * Seleccion metodo de desembolso
   */
  outlaySelection: any;

  /**
   * Información de cuenta de otro banco
   */
  otherBankAccount: any;
  /**
   * Variable para ver/ocultar opciones de multi-producto
   */
  viewOptionMultiProduct = false;

  /**
   * Variable para ver/ocultar opciones de multi-producto
   */
  PassScreenCity: string;
  /**
   * Variable para ver/ocultar opciones de dualidad
   */
  isCardDuality = false;
  checkDisbursement: boolean;
  /**
   * datos de la compra de cartera
   */
  formLoan: any;

  /**
   * Variables para saber si en los productos seleccionados tiene libranzas
   */
  haveLoan = false;

  /**
   * Variable para saber si el cliente esta en normalizacion
   */
  isNormalizacion = false;

  didBackAddLoan = false;
  /**
   * datos de los creditos a retanquear
   */
  creditIndex = 0;
  editCredit = false;
  creditInfo: {
    type: '';
    number: '';
    amount: '';
  };

  creditList = [];
  deleteCredit = false;

  /**
   * Informacion de desembolso de creditos.
   */
  disbursementInfo: any;
  statuscreateaccount: any;

  DisbursementConfigurationModel: any;
  flowPageZoneGray: string;
  ratesLoan: string;
  /**
   * Lista suficiencia documental.
   */
  documentarySufficiencyList: any[];

  /**
   * Variable para saber si se cambio priorizacion.
   */
  priorization = false;

  /**
   * Informacion del seller.
   */
  seller: any;

  /**
   * Variable para saber si se hizo marca en bitacora.
   */
  sellerboolean = false;
  /**
   * Variable para saber que tipo de entidad selecionó.
   */
  RequestEntityOp: any;
  /**
   * Informacion de rate offer.
   */
  rates: string;
  /**
   * Informacion de associate_revolving.
   */
  associate_revolving: any;
  /**
   * Informacion de associate_copy_revolving.
   */
  associate_copy_revolving: boolean;

  validate: any;
  /**
   * Variable para identificar si la libranza fue eliminada de los productos aprobados por PCO.
   */
  wasDeleteLoan: boolean;

  /**
   * Variable para almacenar la información de rescate del usuario.
   */
  private rescueData: IRescueData;

  /**
   * Variable para almacenar la face actual del flujo para taggeo o demas usos
   */
  phase: string;
  /**
   * Variable para almacenar si existe error 01-04 de pco
   */
  private isErrorPco = false;
  /**
   * Variable para almacenar los departamentos
   */
  private districtOptions: any;
  /**
   * Retorna una función con determinada cantidad de tiempo
   * Returns tiem interval function
   *
   * @param {number} delay till this time succed
   * @returns un interval de tiempo
   */
  sleep(delay: number) {
    return new Promise(r => {
      setTimeout(r, delay);
    });
  }

  /**
   * Retorna la fecha con el formato yy-mm-dd T hh:mm:ss
   *
   * *Returns formatted Date yy-mm-dd T hh:mm:ss*
   *
   * @param {Date} Date
   * @returns Fecha en formato yy-mm-dd T hh:mm:ss
   */
  formatDate(date: Date) {
    const dayOfMonth = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hour = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const monthString = month < 10 ? '0' + month : month;
    const dayString = dayOfMonth < 10 ? '0' + dayOfMonth : dayOfMonth;
    return `${year}-${monthString}-${dayString}T${hour}:${minutes}:${seconds}`;
  }

  /**
   * Retorna la fecha con el formato yy-mm-dd T hh:mm:ss
   *
   * *Returns formatted Date yy-mm-dd T hh:mm:ss*
   *
   * @param {Date} Date
   * @returns Fecha en formato yy-mm-dd T hh:mm:ss
   */
  formatDateSpanish(withHour: boolean, time: Date) {
    const monthComplete = time.toLocaleString('es-Co', { month: 'long' });
    const month = monthComplete[0].toUpperCase() + monthComplete.slice(1, 3);
    let date = `${time.getDate()} de ${monthComplete} ${time.getFullYear()}`;
    if (withHour) {
      const hour = time.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
      date += ` a las ${hour}`;
    }
    return date;
  }

  /**
   * Muestra el icono generico de cargando
   *
   * *Shows generic loading icon*
   */
  showGenericLoading() {
    this.loadingService.show();
  }

  /**
   * Oculta el icono generico de cargando
   *
   * *Hides generic loading icon*
   */
  hideGenericLoading() {
    this.loadingService.hide();
  }

  /**
   * Obtener modelo de AbreCuentas
   *
   * *Gets AbreCuentasModel*
   *
   * @returns {AbreCuentasModel} abreCuentasModel
   */
  getAbreCuentasModel(): AbreCuentasModel {
    return this.abreCuentasModel;
  }

  /**
   * Inicializar product destination type
   *
   * *sets productDestinationType*
   *
   * @param {string} type
   */
  setProductDestinationType(type: string | undefined) {
    this.productDestinationType = type;
  }

  getProductDestinationType() {
    return this.productDestinationType;
  }

  /**
   * Inicializar el modelo de AbreCuentas
   *
   * *Sets AbreCuentasModel*
   *
   * @param {AbreCuentasModel} abrecuentasModel
   */
  setAbreCuentasModel(abreCuentasModel: AbreCuentasModel) {
    this.abreCuentasModel = abreCuentasModel;
  }

  /**
   * Inicializar transaction_id
   *
   * *Gets transaction_id*
   *
   * @returns {string} this.abreCuentasModel.protransaction_idspectId
   */
  setTransactionId(transactionId: string) {
    return (this.abreCuentasModel.transaction_id = transactionId);
  }

  /**
   * Obtener transaction_id
   *
   * *Gets transaction_id*
   *
   * @returns {string} this.abreCuentasModel.transaction_id
   */
  getTransactionId() {
    return this.abreCuentasModel.transaction_id;
  }

  /**
   * Inicializar transaction_status
   *
   * *Gets transaction_status*
   *
   * @returns {string} this.abreCuentasModel.transaction_status
   */
  setTransactionStatus(transactionStatus: string) {
    return (this.abreCuentasModel.transaction_status = transactionStatus);
  }

  /**
   * Obtener transaction_status
   *
   * *Gets transaction_status*
   *
   * @returns {string} this.abreCuentasModel.transaction_status
   */
  getTransactionStatus() {
    return this.abreCuentasModel.transaction_status;
  }

  /**
   * Obtener ProspectId
   *
   * *Gets ProspectId*
   *
   * @returns {string} this.abreCuentasModel.prospectId
   */
  getProspectId() {
    return this.abreCuentasModel.prospectId;
  }

  /**
   * Obtener Id de solicitud
   *
   * *Gets Solicitation Id*
   *
   * @returns {string} this.abreCuentasModel.solicitationId
   */
  getSolicitationId() {
    return this.abreCuentasModel.solicitationId;
  }

  /**
   * Obtener Id de solicitud
   *
   * *Gets Solicitation Info*
   *
   * @returns {string} this.abreCuentasModel.solicitationInfo
   */
  getSolicitationInfo() {
    return this.abreCuentasModel.solicitationInfo;
  }

  /**
   * Obtiene los parametros de subida
   *
   * *Gets uploadedParams*
   *
   * @returns {any[]} this.abreCuentasModel.uploadParams
   */
  getUploadParams() {
    return this.abreCuentasModel.uploadParams;
  }

  /**
   * Obtiene las listas de URL
   *
   * *Gets UrlLists*
   *
   * @returns {any[]} this.abreCuentasModel.urlList
   */
  getUrlList() {
    return this.abreCuentasModel.urlList;
  }

  setChannelNotificationData(id) {
    this.abreCuentasModel.channelNot_SolicitationId = id;
  }
  getChannelNotificationData() {
    return this.abreCuentasModel.channelNot_SolicitationId;
  }
  /**
   * Obtiene el tipo de configuracion Bytte
   *
   * *Gets BytteConfig type*
   *
   * @returns {BytteConfigType} this.abreCuentasModel.bytteConfig
   */
  getBytteConfig(): BytteConfigType {
    return this.abreCuentasModel.bytteConfig;
  }

  /**
   * Inicializa la configuracion Bytte
   *
   * *Sets up BytteConfig*
   *
   * @param {BytteConfigType} config
   */
  setBytteConfig(config: BytteConfigType) {
    this.abreCuentasModel.bytteConfig = config;
  }

  /**
   * Obtiene la configuración DsbMobile
   *
   * *Gets DsbMobile Configuration*
   *
   * @returns {DSBMobileConfig} this.abreCuentasModel.dsbMobileCofig
   */
  getDsbMobileConfig(): DSBMobileConfig {
    return this.abreCuentasModel.dsbMobileCofig;
  }

  /**
   * Inicializa la configuración DsbMobile
   *
   * *Sets up DsbMobile*
   *
   * @param {any} config
   */
  setDsbMobileConfig(config: any) {
    this.abreCuentasModel.dsbMobileCofig = config;
  }

  /**
   * Obtiene la configuarción BioCatch
   *
   * *Gets BioCatch configuration*
   *
   * @returns {BioCatchConfigModel} this.abreCuentasModel.biocatchConfig
   */
  getBioCatchConfig(): BioCatchConfigModel {
    return this.abreCuentasModel.biocatchConfig;
  }

  /**
   * Inicializa la configuracion BioCatch
   *
   * *Sets up BioCatch*
   *
   * @param {any} config
   */
  setBioCatchConfig(config: any) {
    this.abreCuentasModel.biocatchConfig = config;
  }

  /**
   * Obtiene Dsb Security Check Expection parámetro
   *
   * *Gets Dsb Security Check Expection parameter*
   *
   * @returns {string} this.abreCuentasModel.dsbSecurityCheckException
   */
  getDsbSecurityCheckException(): string {
    return this.abreCuentasModel.dsbSecurityCheckException;
  }

  /**
   * Inicializa Dsb Security Check Expection parámetro
   *
   * *Sets up Dsb Security Check Expection parameter*
   *
   * @param {string} code
   */
  setDsbSecurityCheckException(code: string) {
    this.abreCuentasModel.dsbSecurityCheckException = code;
  }

  /**
   * Obtiene el parámetro FinancialInfo
   *
   * *Gets FinancialInfo parameter*
   *
   * @returns {FinancialModel} this.abreCuentasModel.financialModel
   */
  getFinancialInfo() {
    return this.abreCuentasModel.financialModel;
  }

  /**
   * Inicializa el parámetro FinancialInfo
   *
   * *Set FinancialInfo parameter*
   *
   * @param {FinancialInfo} financialInfo
   */
  setFinancialInfo(financialInfo: FinancialModel) {
    this.abreCuentasModel.financialModel = financialInfo;
  }

  /**
   * Obtiene el parámetro FinancialSecondHeadlineInfo
   *
   * *Gets FinancialSecondHeadlineInfo parameter*
   *
   * @returns {FinancialSecondHeadlineModel} this.abreCuentasModel.financialSecondHeadlineModel
   */
  getFinancialSecondHeadlineInfo() {
    return this.abreCuentasModel.financialSecondHeadlineModel;
  }

  /**
   * Inicializa el parámetro FinancialInfo
   *
   * *Set FinancialInfo parameter*
   *
   * @param {FinancialInfo} financialInfo
   */
  setFinancialSecondHeadlineInfo(financialSecondHeadlineInfo: FinancialModel) {
    this.abreCuentasModel.financialSecondHeadlineModel =
      financialSecondHeadlineInfo;
  }

  /**
   * Obtiene el parámetro OtherFinancialInfo
   *
   * *Gets OtherFinancialInfo parameter*
   *
   * @returns {OtherFinancialModel} this.abreCuentasModel.otherFinancialModel
   */
  getOtherFinancialInfo() {
    return this.abreCuentasModel.otherFinancialModel;
  }

  /**
   * Inicializa el parámetro FinancialInfo
   *
   * *Set FinancialInfo parameter*
   *
   * @param {FinancialInfo} financialInfo
   */
  setOtherFinancialInfo(otherFinancialInfo: OtherFinancialModel) {
    this.abreCuentasModel.otherFinancialModel = otherFinancialInfo;
  }

  /**
   * Obtiene el parámetro OtherFinancialInfo
   *
   * *Gets OtherFinancialInfo parameter*
   *
   * @returns {OtherFinancialModel} this.abreCuentasModel.otherFinancialSecondHeadlineModel
   */
  getOtherFinancialSecondHeadlineInfo() {
    return this.abreCuentasModel.otherFinancialSecondHeadlineModel;
  }

  /**
   * Inicializa el parámetro FinancialInfo
   *
   * *Set FinancialInfo parameter*
   *
   * @param {FinancialInfo} financialInfo
   */
  setOtherFinancialSecondHeadlineInfo(
    otherFinancialSecondHeadlineModel: OtherFinancialSecondHeadlineModel,
  ) {
    this.abreCuentasModel.otherFinancialSecondHeadlineModel =
      otherFinancialSecondHeadlineModel;
  }

  /**
   * Obtiene el parámetro ContactInfo
   *
   * *Gets ContactInfo parameter*
   *
   * @returns {ContactModel} this.abreCuentasModel.ContactModel
   */
  getContactInfo() {
    return this.abreCuentasModel.ContactModel;
  }

  /**
   * Inicializa el parámetro ContactInfo
   *
   * *Sets ContactInfo parameter*
   *
   * @param {ContactModel} contactInfo
   */
  setContactInfo(contactInfo: ContactModel) {
    this.abreCuentasModel.ContactModel = contactInfo;
  }

  getBasicInfo() {
    return this.abreCuentasModel.basicModel;
  }

  setBasictInfo(basicInfo: IBasciModel) {
    this.abreCuentasModel.basicModel = basicInfo;
  }

  /**
   * Inicializa el parámetro foreignProductsInfo
   * *Sets foreignProductsInfo parameter*
   *
   * @param {ForeignProductsModel} productInfo
   */
  setProductInfo(productInfo: ForeignProductsModel) {
    this.abreCuentasModel.foreignProductsInfo = productInfo;
  }

  /**
   * Obtiene el parámetro foreignProductsInfo
   * *Gets foreignProductsInfo parameter*
   *
   * @returns {ForeignProductsModel} this.abreCuentasModel.foreignProductsInfo
   */
  getProductInfo() {
    return this.abreCuentasModel.foreignProductsInfo;
  }

  /**
   * Inicializa el parámetro ethnicGroupInfo
   * *Sets ethnicGroupInfo parameter*
   *
   * @param {EthnicGroupModel} ethnicGroupInfo
   */
  setEthnicGroupInfo(ethnicGroupInfo: EthnicGroupModel) {
    this.abreCuentasModel.ethnicGroupInfo = ethnicGroupInfo;
  }

  /**
   * Obtiene el parámetro maritalStatusModel
   * *Gets maritalStatusModel parameter*
   *
   * @returns {EthnicGroupModel} *this.abreCuentasModel.maritalStatusModel*
   */
  getEthnicGroupInfo() {
    return this.abreCuentasModel.ethnicGroupInfo;
  }
  /**
   * Inicializa el parámetro birthplaceInfo
   * *Sets birthplaceInfo parameter*
   *
   * @param {CityModel} birthplaceInfo
   */
  setBirthplaceInfo(birthplaceInfo: CityModel) {
    this.abreCuentasModel.birthplaceInfo = birthplaceInfo;
  }

  /**
   * Inicializa el parámetro birthCountry
   * *Sets birthCountry parameter*
   *
   * @param {CountryModel} birthCountry
   */
  setBirthCountry(birthCountry: CountryModel) {
    this.abreCuentasModel.birthCountry = birthCountry;
  }

  /**
   * Inicializa el parámetro maritalStatusModel
   * *Sets maritalStatusModel parameter*
   *
   * @param {MaritalStatusModel} maritalStatusModel
   */
  setMaritalStatusInfo(maritalStatusModel: MaritalStatusModel) {
    this.abreCuentasModel.maritalStatusModel = maritalStatusModel;
  }

  /**
   * Inicializa el parámetro maritalStatusModel Segundo Titular
   * *Sets maritalStatusModel parameter*
   *
   * @param {MaritalStatusSecondHeadlineModel} MaritalStatusSecondHeadlineModel
   */
  setMaritalStatusSecondHeadline(
    maritalStatusSecondHeadlineModel: MaritalStatusSecondHeadlineModel,
  ) {
    this.abreCuentasModel.maritalStatusSecondHeadlineModel =
      maritalStatusSecondHeadlineModel;
  }

  /**
   * Obtiene el parámetro maritalStatusModel
   * *Gets maritalStatusModel parameter*
   *
   * @returns {.maritalStatusSecondHeadlineModel} *this.abreCuentasModel.maritalStatusModel*
   */
  getMaritalStatusSecondHeadLine() {
    return this.abreCuentasModel.maritalStatusSecondHeadlineModel;
  }

  /**
   * Inicializa el parámetro SecondHeadlineModel
   * *Sets SecondHeadlineModel parameter*
   *
   * @param {SecondHeadlineModel} SecondHeadlineModel
   */
  setSecondHeadline(secondHeadlineModel: SecondHeadlineModel) {
    this.abreCuentasModel.secondHeadlineModel = secondHeadlineModel;
  }

  /**
   * Obtiene el parámetro SecondHeadlineModel
   * *Gets SecondHeadlineModel parameter*
   *
   * @returns {SecondHeadlineModel} *this.abreCuentasModel.SecondHeadline*
   */
  getSecondHeadline() {
    return this.abreCuentasModel.secondHeadlineModel;
  }

  /**
   * Inicializa el parámetro BasicInfoSecondHeadlineModel
   * *Sets BasicInfoSecondHeadlineModel parameter*
   *
   * @param {BasicInfoSecondHeadlineModel} BasicInfoSecondHeadlineModel
   */
  setBasicInfoSecondHeadline(
    basicInfosecondHeadlineModel: BasicInfoSecondHeadlineModel,
  ) {
    this.abreCuentasModel.basicInfoSecondHeadlineModel =
      basicInfosecondHeadlineModel;
  }

  /**
   * Obtiene el parámetro SecondHeadlineModel
   * *Gets SecondHeadlineModel parameter*
   *
   * @returns {SecondHeadlineModel} *this.abreCuentasModel.SecondHeadline*
   */
  getBasicInfoSecondHeadline() {
    return this.abreCuentasModel.basicInfoSecondHeadlineModel;
  }

  /**
   * Inicializa el parámetro ContactSecondHeadlineModel
   * *Sets ContactSecondHeadlineModel parameter*
   *
   * @param {ContactSecondHeadlineModel} ContactSecondHeadlineModel
   */
  setContactInfoSecondHeadline(
    contactSecondHeadlineModel: ContactSecondHeadlineModel,
  ) {
    this.abreCuentasModel.contactSecondHeadlineModel =
      contactSecondHeadlineModel;
  }

  /**
   * Obtiene el parámetro ContactSecondHeadlineModel
   * *Gets ContactSecondHeadlineModel parameter*
   *
   * @returns {contactContactSecondHeadlineModel} *this.abreCuentasModel.contactContactSecondHeadlineModel*
   */
  getContactInfoSecondHeadline() {
    return this.abreCuentasModel.contactSecondHeadlineModel;
  }

  /**
   * Obtiene el parámetro birthplaceInfo
   * *Gets birthplaceInfo parameter*
   *
   * @returns {CityModel} *this.abreCuentasModel.birthplaceInfo*
   */
  getBirthplaceInfo() {
    return this.abreCuentasModel.birthplaceInfo;
  }

  /**
   * Obtiene el parámetro birthCountry
   * *Gets birthCountry parameter*
   *
   * @returns {CountryModel} *this.abreCuentasModel.birthCountry*
   */
  getBirthCountry() {
    return this.abreCuentasModel.birthCountry;
  }

  /**
   * Obtiene el parámetro maritalStatusModel del segundo titular
   * *Gets maritalStatusModel parameter*
   *
   * @returns {MaritalStatusModel} *this.abreCuentasModel.maritalStatusModel*
   */
  getMaritalStatusInfo() {
    return this.abreCuentasModel.maritalStatusModel;
  }

  /**
   * Inicializa el parámetro AccountSelectionModel
   * *Sets AccountSelectionModel parameter*
   *
   * @param {AccountSelectionModel} accountSelectionModel
   */
  setAccountSelectionInfo(accountSelectionModel: AccountSelectionModel) {
    this.abreCuentasModel.accountSelectionModel = accountSelectionModel;
  }
  /**
   * Obtiene el parámetro accountSelectionModel
   * *Gets accountSelectionModel parameter*
   *
   * @returns {AccountSelectionModel} *this.abreCuentasModel.accountSelectionModel*
   */
  getAccountSelectionInfo() {
    return this.abreCuentasModel.accountSelectionModel;
  }

  /**
   * Inicializa el parámetro prospectId
   *
   * *Sets prospectId parameter*
   *
   * @param {string} id
   */
  setProspectId(id: string) {
    this.abreCuentasModel.prospectId = id;
  }

  /**
   * Inicializa el parámetro solicitationId
   *
   * *Sets solicitationId parameter*
   *
   * @param {string} id
   */
  setSolicitationId(id: string) {
    this.abreCuentasModel.solicitationId = id;
  }

  /**
   * Inicializa el parámetro solicitationInfo
   *
   * *Sets solicitationInfo parameter*
   *
   * @param {any[]} info
   */
  setSolicitationInfo(info: any[]) {
    this.abreCuentasModel.solicitationInfo = info;
  }

  /**
   * Inicializa el parámetro uploadParams
   *
   * *Sets uploadParams parameter*
   *
   * @param {any[]} uploadParams
   */
  setUploadParams(uploadParams: any[]) {
    this.abreCuentasModel.uploadParams = uploadParams;
  }

  /**
   * Inicializa el parámetro urlList
   *
   * *Sets urlList parameter*
   *
   * @param {any[]} urlList
   */
  setUrlList(urlList: any[]) {
    this.abreCuentasModel.urlList = urlList;
  }

  /**
   * Obtiene el parámetro domicilioModel
   *
   * *Gets domicilioModel parameter*
   *
   * @returns {DomicilioModel} this.abreCuentasModel.domicilioModel
   */
  getDomicilioModel() {
    return this.abreCuentasModel.domicilioModel;
  }

  /**
   * Obtiene el parámetro listsModel
   *
   * *Gets listsModel parameter*
   *
   * @returns {ListsModel} *this.abreCuentasModel.listsModel*
   */
  getListsModel() {
    return this.abreCuentasModel.listsModel;
  }

  /**
   * Obtiene el parámetro fiModel
   *
   * *Get fiModel parameter*
   *
   * @returns {FiModel} *this.abreCuentasModel.fiModel*
   */
  getFiModel() {
    return this.abreCuentasModel.fiModel;
  }

  /**
   * Inicializa el parámetro fiModel
   *
   * *Sets fiModel parameter*
   *
   * @param {FiModel} fiModel
   */
  setFiModel(fiModel: FiModel) {
    this.abreCuentasModel.fiModel = fiModel;
  }

  /**
   * Obtiene el parámetro pldModel
   *
   * *Gets pldModel parameter*
   *
   * @returns {PldModel} this.abreCuentasModel.pldModel
   */
  getPldModel() {
    return this.abreCuentasModel.pldModel;
  }

  /**
   * Obtiene el parámetro photosModel
   *
   * *Gets photosModel parameter*
   *
   * @returns {PhotosModel} this.abreCuentasModel.photosModel
   */
  getPhotosModel(): PhotosModel {
    return this.abreCuentasModel.photosModel;
  }

  /**
   * Inicializa el parámetro photosModel
   *
   * *Sets photosModel parameter*
   *
   * @param {PhotosModel} photosModel
   */
  setPhotosModel(photosModel: PhotosModel) {
    this.abreCuentasModel.photosModel = photosModel;
  }

  /**
   * Obtiene el parámetro photosModel
   *
   * *Gets photosModel parameter*
   *
   * @param {string} property
   * @returns {PhotosModel} this.abreCuentasModel.photosModel[property]
   */
  getPhotosProperty(property: string) {
    return this.abreCuentasModel.photosModel[property];
  }

  /**
   * Inicializa el parámetro photosModel[property] igual value
   *
   * *Sets photosModel[property] parameter equal to value*
   *
   * @param {string} property
   * @param {any} value
   */
  setPhotosProperty(property: string, value: any) {
    this.abreCuentasModel.photosModel[property] = value;
  }

  /**
   * Obtiene el parámetro domicilioModel
   *
   * *Gets domicilioModel parameter*
   *
   * @param {string} property
   * @returns {DomicilioModel} this.abreCuentasModel.domicilioModel[property]
   */
  getDomicilioProperty(property: string) {
    return this.abreCuentasModel.domicilioModel[property];
  }

  /**
   * Inicializa el parámetro domicilioModel[property] igual value
   *
   * *Sets domicilioModel[property] parameter equal to value*
   *
   * @param {string} property
   * @param {any} value
   */
  setDomicilioProperty(property: string, value: any) {
    this.abreCuentasModel.domicilioModel[property] = value;
  }

  /**
   * Obtiene el parámetro fiModel
   *
   * *Gets fiModel parameter*
   *
   * @param {string} property
   * @returns {FiModel} this.abreCuentasModel.fiModel[property]
   */
  getFiProperty(property: string) {
    return this.abreCuentasModel.fiModel[property];
  }

  /**
   * Inicializa el parámetro fiModel[property] igual value
   *
   * *Sets fiModel[property] parameter equal to value*
   *
   * @param {string} property
   * @param {any} value
   */
  setFiProperty(property: string, value: any) {
    this.abreCuentasModel.fiModel[property] = value;
  }

  /**
   * Inicializa el parámetro fiModel[property] igual value secondheadline
   *
   * *Sets fiModel[property] parameter equal to value secondheadline*
   *
   * @param {string} property
   * @param {any} value
   */
  setFiPropertySecondHeadline(property: string, value: any) {
    this.abreCuentasModel.fiSecondHeadlineModel[property] = value;
  }

  getFiPropertySecondHeadline(property: string) {
    return this.abreCuentasModel.fiSecondHeadlineModel[property];
  }

  /**
   * Obtiene el parámetro errorModel
   *
   * *Gets errorModel parameter*
   *
   * @returns {ErrorModel} this.abreCuentasModel.errorModel
   */
  getErrorProperty() {
    return this.abreCuentasModel.errorModel;
  }

  /**
   * Inicializa el parámetro errorModel igual model
   *
   * *Sets errorModel parameter equal to model*
   *
   * @param {ErrorModel} model
   */
  setErrorProperty(model: ErrorModel) {
    this.abreCuentasModel.errorModel = model;
  }

  /**
   * Obtiene el parámetro errorModel
   *
   * *Gets errorModel parameter*
   *
   * @returns {ErrorDateModel} this.abreCuentasModel.errorDateModel
   */
  getErrorDateProperty() {
    return this.abreCuentasModel.errorDateModel;
  }

  /**
   * Inicializa el parámetro errorDateModel igual model
   *
   * *Sets errorDateModel parameter equal to model*
   *
   * @param {any} model
   */
  setErrorDateProperty(model: any) {
    this.abreCuentasModel.errorDateModel = model;
  }

  /**
   * Inicializa el parámetro documentModel igual model
   *
   * *Sets documentModel parameter equal to model*
   *
   * @param {DocumentModel} model
   */
  setDocumentInfo(model: DocumentModel) {
    this.abreCuentasModel.documentModel = model;
  }

  /**
   * Obtiene el parámetro documentModel
   *
   * *Gets documentModel parameter*
   *
   * @returns {DocumentModel} this.abreCuentasModel.documentModel
   */
  getDocumentInfo() {
    return this.abreCuentasModel.documentModel;
  }

  /**
   * Inicializa el parámetro documentModel igual model
   *
   * *Sets documentModel parameter equal to model*
   *
   * @param {DocumentModel} model
   */
  setPostlogin(isPostlogin: boolean) {
    this.abreCuentasModel.isPostlogin = isPostlogin;
  }

  /**
   * Obtiene el parámetro documentModel
   *
   * *Gets documentModel parameter*
   *
   * @returns {DocumentModel} this.abreCuentasModel.documentModel
   */
  getPostlogin() {
    return this.abreCuentasModel.isPostlogin;
  }

  /**
   * Obtiene el parámetro pldModel[property]
   *
   * *Gets pldModel[property] parameter*
   *
   * @param {string} property
   * @returns {PldModel} this.abreCuentasModel.pldModel[property]
   */
  getPldProperty(property: string) {
    return this.abreCuentasModel.pldModel[property];
  }

  /**
   * Inicializa el parámetro pldModel[property] igual value
   *
   * *Sets pldModel[property] parameter equal to value*
   *
   * @param {string} property
   * @param {any} value
   */
  setPldProperty(property: string, value: any) {
    this.abreCuentasModel.pldModel[property] = value;
  }

  /**
   * @param type (event,page)
   * @param key (key)
   * @param data (data sett)
   */
  setDataTagg(type, key, page, pageEvent, data) {
    if (type == 'page') {
      this.dataTagg.PAGEVIEW[`pv${page}${key}`].value = data;
    } else if (type == 'event') {
      this.dataTagg.EVENT[`pv${page}E${pageEvent}setData`][`pv${page}E${pageEvent}${key}`].value = data;
    }

  }

  setTaggeo(data) {
    this.dataTagg = data;
  }

  getDataTagg() {
    return this.dataTagg;
  }

  getBusinessConfig(key: OpEnum) {
    return this.abreCuentasModel.businessConfigMap[key.toString()];
  }

  setBusinessConfig(key: string, config: any) {
    return (this.abreCuentasModel.businessConfigMap[key] = config);
  }

  setIntentoOtp(intentos: number) {
    this.intentos = intentos;
  }

  getIntentoOtp() {
    return this.intentos;
  }

  setValidationOtp(intentos: number) {
    this.validationOtp = intentos;
  }

  getValidationOtp() {
    return this.validationOtp;
  }

  /**
   * Obtiene el parámetro detailAccountModel
   *
   * *Gets detailAccountModel parameter*
   *
   * @returns {DetailAccountModel} this.abreCuentasModel.detailAccountModel
   */
  getDetailAccountCreation() {
    return this.abreCuentasModel.detailAccountModel;
  }

  /**
   * Inicializa el parámetro detailAccountModel igual detailAccountInfo
   *
   * *Sets detailAccountModel parameter equal to detailAccountInfo*
   *
   * @param {DetailAccountModel} detailAccountInfo
   */
  setDetailAccountCreation(detailAccountInfo: DetailAccountModel) {
    this.abreCuentasModel.detailAccountModel = detailAccountInfo;
  }

  /**
   * Obtiene el parámetro DetailRevolvingCreditModel
   *
   * *Gets DetailRevolvingCreditModel parameter*
   *
   * @returns {DetailRevolvingCreditModel} this.abreCuentasModel.detailRevolvingCreditModel
   */
  getDetailRevolvingCreditCreation() {
    return this.abreCuentasModel.detailRevolvingCreditModel;
  }

  /**
   * Inicializa el parámetro detailRevolvingCreditModel igual detailRevolvingCreditInfo
   *
   * *Sets detailRevolvingCreditModel parameter equal to detailRevolvingCreditInfo*
   *
   * @param {DetailRevolvingCreditModel} detailAccountInfo
   */
  setDetailRevolvingCreditCreation(
    detailRevolvingCreditInfo: DetailRevolvingCreditModel,
  ) {
    this.abreCuentasModel.detailRevolvingCreditModel =
      detailRevolvingCreditInfo;
  }

  /**
   * Obtiene el parámetro employedContractModel
   *
   * *Gets employedContractModel parameter*
   *
   * @returns {EmployedContractModel} this.abreCuentasModel.employedContractModel
   */
  getEmployedContractModel() {
    return this.abreCuentasModel.employedContractModel;
  }

  /**
   * Inicializa el parámetro employedContractModel igual employedContractModel
   *
   * *Sets employedContractModel parameter equal to employedContractModel*
   *
   * @param {EmployedContractModel} employedContractModel
   */
  setEmployedContractModel(employedContractModel: EmployedContractModel) {
    this.abreCuentasModel.employedContractModel = employedContractModel;
  }

  /**
   * Obtiene el parámetro employedContractSecondHeadlineModel
   *
   * *Gets employedContractSecondHeadlineModel parameter*
   *
   * @returns {EmployedContractSecondHeadlineModel} this.abreCuentasModel.employedContractSecondHeadlineModel
   */
  getEmployedContractSecondHeadlineModel() {
    return this.abreCuentasModel.employedContractSecondHeadlineModel;
  }

  /**
   * Inicializa el parámetro employedContractSecondHeadlineModel igual employedContractSecondHeadlineModel
   *
   * *Sets employedContractSecondHeadlineModel parameter equal to employedContractSecondHeadlineModel*
   *
   * @param {employedContractSecondHeadlineModel} employedContractSecondHeadlineModel
   */
  setEmployedContractSecondHeadlineModel(
    employedContractSecondHeadlineModel: EmployedContractSecondHeadlineModel,
  ) {
    this.abreCuentasModel.employedContractSecondHeadlineModel =
      employedContractSecondHeadlineModel;
  }

  /**
   * Obtiene la lista CONTRACTS_LIST, donde están los tipos de contratos laborales para que el usuario escoja
   *
   * *Get CONTRACTS_LIST list there are different types of labor contracts that user must choose*
   *
   * @returns {TypeContractModel[]} *CONTRACTS_LIST*
   */
  getListTypeContract(): TypeContractModel[] {
    return CONTRACTS_LIST;
  }

  /**
   * Inicializa errorProperty() partiendo de errorInfo proporcionado por la variable code
   *
   * *Sets errorProperty() from errorInfo given by code variable*
   *
   * @param {string} code
   */
  caseInfoError(code: string) {
    if (code === '200') {
      return;
    }
    // tslint:disable-next-line: no-duplicate-case
    switch (code) {
      case ERROR_111.CODE:
        this.errorInfo = ERROR_111.DATA;
        // this.errorInfo.image = this.getImageLottieError();
        break;
      case ERROR_112.CODE:
        this.errorInfo = ERROR_112.DATA;
        // this.errorInfo.image = this.getImageLottieError();
        break;
      case ERROR_113.CODE:
        this.errorInfo = ERROR_113.DATA;
        // this.errorInfo.image = this.getImageLottieError();
        break;
      case ERROR_102.CODE:
        this.errorInfo =
          this.chanelid == CHANNEL.PORTALO.CODE
            ? ERROR_133.DATA
            : ERROR_102.DATA;
        break;
      case ERROR_103.CODE:
        this.errorInfo = ERROR_103.DATA;
        break;
      case ERROR_104.CODE:
        this.errorInfo = ERROR_104.DATA;
        break;
      case ERROR_105.CODE:
        console.log('this.chanelid', this.chanelid);
        this.errorInfo =
          this.chanelid == CHANNEL.PORTALO.CODE
            ? ERROR_133.DATA
            : ERROR_105.DATA;
        this.errorInfo.title = this.helperService.stringFormat(
          ERROR_105.DATA.title,
          this.getDocumentInfo().firstname,
        );
        break;
      case ERROR_107.CODE:
        this.errorInfo = ERROR_107.DATA;
        if (this.getIsErrorPco()) {
          this.errorInfo = ERROR_0104.DATA;
          this.setIsErrorPco(false);
        }
        break;
      case ERROR_108.CODE:
        this.errorInfo = ERROR_108.DATA;
        break;
      case ERROR_121.CODE:
        this.errorInfo = ERROR_121.DATA;
        break;
      case ERROR_401.CODE:
        this.errorInfo = ERROR_401.DATA;
        break;
      case ERROR_122.CODE:
        this.errorInfo = ERROR_122.DATA;
        this.errorInfo.title = this.helperService.stringFormat(
          ERROR_122.DATA.title,
          this.getDocumentInfo().firstname,
        );
        break;
      case ERROR_123.CODE:
        this.errorInfo = ERROR_123.DATA;
        this.errorInfo.title = this.helperService.stringFormat(
          ERROR_123.DATA.title,
          this.getDocumentInfo().firstname,
        );
        break;
      case ERROR_124.CODE:
        this.errorInfo = ERROR_124.DATA;
        break;
      case ERROR_125.CODE:
        this.errorInfo = ERROR_125.DATA;
        break;
      case ERROR_126.CODE:
        this.errorInfo = ERROR_126.DATA;
        this.errorInfo.title = this.helperService.stringFormat(
          ERROR_126.DATA.title,
          this.getDocumentInfo().firstname,
        );
        break;
      case ERROR_127.CODE:
        this.errorInfo = ERROR_127.DATA;
        break;
      case ERROR_128.CODE:
        this.errorInfo = ERROR_128.DATA;
        this.errorInfo.title = this.helperService.stringFormat(
          ERROR_128.DATA.title,
          this.getDocumentInfo().firstname,
        );
        break;
      case ERROR_129.CODE:
        this.errorInfo = ERROR_129.DATA;
        break;
      case ERROR_130.CODE:
        this.errorInfo = ERROR_130.DATA;
        const specificInfo = this.errorInfo.specificInfo;
        // tslint:disable-next-line: early-exit
        if (specificInfo !== undefined) {
          specificInfo.value = this.helperService.stringFormat(
            ERROR_130.DATA.specificInfo.value,
            this.getSolicitationId(),
          );
        }
        break;
      case ERROR_500.CODE:
        this.errorInfo = ERROR_500.DATA;
        break;
      case ERROR_501.CODE:
        this.errorInfo = ERROR_501.DATA;
        break;
      case ERROR_502.CODE:
        const second_headline = this.getSecondHeadline();
        const selectedOccupation =
          typeof second_headline === 'undefined' ||
            !second_headline.has_second_headline
            ? this.getOccupationSelected()
            : this.getOccupationSelectedSecondHeadline();
        this.errorInfo.buttonLabel =
          this.copiesService.copies.error_back_to_edit_date_end;
        this.errorInfo.type = 'date-error';
        if (selectedOccupation.id === 1) {
          const type_contract =
            typeof second_headline === 'undefined' ||
              !second_headline.has_second_headline
              ? this.getEmployedContractModel()
              : this.getEmployedContractSecondHeadlineModel();
          this.errorInfo.title = this.helperService.stringFormat(
            ERROR_502.DATA.title,
            type_contract.typeContract.timeText.toString(),
          );
          this.errorInfo.buttonAction = '$exit';
          this.errorInfo.description = this.helperService.stringFormat(
            ERROR_502.DATA.description,
            type_contract.typeContract.timeText.toString(),
          );
          break;
        }

        this.errorInfo.title = this.helperService.stringFormat(
          ERROR_502.DATA.title,
          this.copiesService.copies.independent_occupation.title_date_error,
        );
        this.errorInfo.description = this.helperService.stringFormat(
          ERROR_502.DATA.description,
          this.copiesService.copies.independent_occupation.title_date_error,
        );

        break;
      case ERROR_512.CODE:
        this.errorInfo = ERROR_512.DATA;
        break;
      case ERROR_514.CODE:
        this.errorInfo = ERROR_514.DATA;
        break;
      case ERROR_DBS.CODE:
        this.errorInfo = ERROR_DBS.DATA;
        this.errorInfo.description = this.helperService.stringFormat(
          ERROR_105.DATA.title,
          this.abreCuentasModel.dsbSecurityCheckException,
        );
        break;
      case ERROR_BRANCH.CODE_1:
      case ERROR_BRANCH.CODE_2:
      case ERROR_BRANCH.CODE_3:
        this.errorInfo = ERROR_BRANCH.DATA;
        break;
      case ERROR_600.CODE:
        this.errorInfo = ERROR_600.DATA;
        break;
      case ERROR_601.CODE:
        this.errorInfo = ERROR_601.DATA;
        break;
      case ERROR_602.CODE:
        this.errorInfo = ERROR_602.DATA;
        break;
      case ERROR_603.CODE:
        this.errorInfo = ERROR_603.DATA;
        break;
      case ERROR_NONE.CODE:
        this.errorInfo = ERROR_NONE.DATA;
        break;
      case ERROR_404.CODE:
        this.errorInfo = ERROR_404.DATA;
        break;
      case ERROR_403.CODE:
        this.errorInfo = ERROR_403.DATA;
        break;
      case ERROR_TECH.CODE:
        this.errorInfo = ERROR_TECH.DATA;
        break;
      case ERROR_400.CODE:
        this.errorInfo = ERROR_400.DATA;
        break;
      case ERROR_402.CODE:
        this.errorInfo = ERROR_402.DATA;
        break;
      case ERROR_131.CODE:
        this.errorInfo = ERROR_131.DATA;
        break;
      case ERROR_132.CODE:
        this.errorInfo = ERROR_132.DATA;
        break;
      case ERROR_LIB.CODE:
        this.errorInfo = ERROR_LIB.DATA;
        break;
      case ERROR_142.CODE:
        this.errorInfo = ERROR_142.DATA;
        break;
      case ERROR_140.CODE:
        this.errorInfo = ERROR_140.DATA;
        break;
      case ERROR_141.CODE:
        this.errorInfo = ERROR_141.DATA;
        break;
      case ERROR_134.CODE:
        this.errorInfo = ERROR_134.DATA;
        break;
      case ERROR_135.CODE:
        this.errorInfo = ERROR_135.DATA;
        break;
      case ERROR_137.CODE:
        this.errorInfo = ERROR_137.DATA;
        const specificInfo2 = this.errorInfo.specificInfo;
        // tslint:disable-next-line: early-exit
        if (specificInfo2 !== undefined) {
          specificInfo2.value = this.helperService.stringFormat(
            ERROR_137.DATA.specificInfo.value,
            this.getSolicitationId(),
          );
        }
        break;
      case ERROR_136.CODE:
        this.errorInfo = ERROR_136.DATA;
        const specificInfo3 = this.errorInfo.specificInfo;
        // tslint:disable-next-line: early-exit
        if (specificInfo3 !== undefined) {
          specificInfo3.value = this.helperService.stringFormat(
            ERROR_137.DATA.specificInfo.value,
            this.getSolicitationId(),
          );
        }
        break;
      case ERROR_138.CODE:
        this.errorInfo = ERROR_138.DATA;
        const specificInfo4 = this.errorInfo.specificInfo;
        // tslint:disable-next-line: early-exit
        if (specificInfo4 !== undefined) {
          specificInfo4.value = this.helperService.stringFormat(
            ERROR_138.DATA.specificInfo.value,
            this.getSolicitationId(),
          );
        }
        break;
      case ERROR_139.CODE:
        this.errorInfo = ERROR_139.DATA;
        break;
      case ERROR_143.CODE:
        this.errorInfo = ERROR_143.DATA;
        const specificInfo5 = this.errorInfo.specificInfo;
        // tslint:disable-next-line: early-exit
        if (specificInfo5 !== undefined) {
          specificInfo5.value = this.helperService.stringFormat(
            ERROR_143.DATA.specificInfo.value,
            this.getSolicitationId(),
          );
        }
        break;
      case ERROR_999.CODE:
        this.errorInfo = ERROR_999.DATA;
        // this.errorInfo.image = this.getImageLottieError();
        break;
      default:
        break;
    }
    this.setErrorProperty(this.errorInfo);
    console.log('----->', this.getErrorProperty());
  }

  /**
   * Obtiene la lista occupationSelected
   *
   * *Gets occupationSelectedT list*
   *
   * @returns {OccupationModel} this.abreCuentasModel.occupationSelected
   */
  getOccupationSelected() {
    return this.abreCuentasModel.occupationSelected;
  }

  /**
   * Obtiene la lista occupationSelected
   *
   * *Gets occupationSelectedT list*
   *
   * @returns {OccupationSecondHeadlineModel} this.abreCuentasModel.occupationSelected
   */
  getOccupationSelectedSecondHeadline() {
    return this.abreCuentasModel.occupationSelectedSecondHeadline;
  }

  /**
   * Inicializa el parámetro occupationSelected igual occupation
   *
   * *Sets occupationSelected parameter equal to occupation*
   *
   * @param {any} occupation
   */
  setOccupationSelected(occupation: any) {
    console.log(occupation);
    this.abreCuentasModel.occupationSelected = occupation;
  }

  /**
   * Inicializa el parámetro occupationSelected igual occupation
   *
   * *Sets occupationSelected parameter equal to occupation*
   *
   * @param {any} occupation
   */
  setOccupationSelectedSecondHeadline(occupation: any) {
    this.abreCuentasModel.occupationSelectedSecondHeadline = occupation;
  }

  /**
   * Obtiene el parámetro de officeModel[index]
   *
   * *Gets officeModel[index] parameter*
   *
   * @param {string}  index
   * @returns {OfficeModel} this.abreCuentasModel.officeModel[index]
   */
  getOfficeInfo(index: string) {
    const officeInfo = this.abreCuentasModel.officeModel[index];
    if (officeInfo) {
      return officeInfo;
    }
    return {
      occupation_id: 0,
      company_name: '',
      company_nameInput: '',
      address: {
        city: new CityModel(),
        address: '',
        detail: '',
        addressInput: '',
      },
      office_number: '',
    };
  }

  /**
   * Inicializa el parámetro officeModel[index] igual officeModel
   *
   * *Sets officeModel[index] parameter equal to officeModel*
   *
   * @param {string} index
   * @param {OfficeModel} officeModel
   */
  setOfficeInfo(index: string, officeModel: OfficeModel) {
    this.abreCuentasModel.officeModel[index] = officeModel;
  }

  /**
   * Obtiene el parámetro de OfficeSecondHeadlineModel[index]
   *
   * *Gets OfficeSecondHeadlineModel[index] parameter*
   *
   * @param {string}  index
   * @returns {OfficeSecondHeadlineModel} this.abreCuentasModel.OfficeSecondHeadlineModel[index]
   */
  getOfficeSecondHeadlineInfo(index: string) {
    const officeInfo = this.abreCuentasModel.officeSecondHeadlineModel[index];
    if (officeInfo) {
      return officeInfo;
    }
    return {
      occupation_id: 0,
      company_name: '',
      company_nameInput: '',
      address: {
        city: new CityModel(),
        address: '',
        detail: '',
        addressInput: '',
      },
      office_number: '',
    };
  }

  /**
   * Inicializa el parámetro OfficeSecondHeadlineModel[index] igual OfficeSecondHeadlineModel
   *
   * *Sets OfficeSecondHeadlineModel[index] parameter equal to OfficeSecondHeadlineModel*
   *
   * @param {string} index
   * @param {OfficeSecondHeadlineModel} OfficeSecondHeadlineModel
   */
  setOfficeSecondHeadlineInfo(
    index: string,
    officeSecondHeadlineModel: OfficeSecondHeadlineModel,
  ) {
    this.abreCuentasModel.officeSecondHeadlineModel[index] =
      officeSecondHeadlineModel;
  }

  /**
   * Obtiene el parámetro de LiveAbroadModel
   *
   * *Gets LiveAbroadModel parameter*
   *
   * @returns {LiveAbroadModel} this.abreCuentasModel.LiveAbroadModel
   */
  getLiveAbroad() {
    return this.abreCuentasModel.LiveAbroadModel;
  }

  /**
   * Inicializa el parámetro LiveAbroadModel igual liveAbroadModel
   *
   * *Sets LiveAbroadModel  parameter equal to liveAbroadModel*
   *
   * @param {LiveAbroadModel} liveAbroadModel
   */
  setLiveAbroad(liveAbroadModel: LiveAbroadModel) {
    this.abreCuentasModel.LiveAbroadModel = liveAbroadModel;
  }

  /**
   * Obtiene el parámetro de foreignCurrencyModel
   *
   * *Gets foreignCurrencyModel*
   *
   * @returns {ForeignCurrencyModel} *this.abreCuentasModel.foreignCurrencyModel*
   */
  getForeignCurrency() {
    return this.abreCuentasModel.foreignCurrencyModel;
  }

  /**
   * Inicializa el parámetro foreignCurrencyModel igual foreignCurrencyModel
   *
   * *Sets foreignCurrencyModel  parameter equal to foreignCurrencyModel*
   *
   * @param {ForeignCurrencyModel} foreignCurrencyModel
   */
  setForeignCurrency(foreignCurrencyModel: ForeignCurrencyModel) {
    this.abreCuentasModel.foreignCurrencyModel = foreignCurrencyModel;
  }

  /**
   * Obtiene la lista parámetro de operationCurrencyList
   *
   * *Gets operationCurrencyList list*
   *
   * @returns {any[]} this.abreCuentasModel.operationCurrencyList
   */
  getOperationCurrencyList() {
    return this.abreCuentasModel.operationCurrencyList;
  }

  /**
   * Inicializa el parámetro operationCurrencyList igual operationCurrencyList
   *
   * *Sets operationCurrencyList  parameter equal to operationCurrencyList*
   *
   *  @param {any} operationCurrencyList
   */
  setOperationCurrencyList(operationCurrencyList: any) {
    this.abreCuentasModel.operationCurrencyList = operationCurrencyList;
  }

  /**
   * Obtiene el parámetro de foreignProductsSelected
   *
   * *Gets foreignProductsSelected parameter*
   *
   * @returns {LiveAbroadModel} this.abreCuentasModel.foreignProductsSelected
   */
  getForeignSelected() {
    return this.abreCuentasModel.foreignProductsSelected;
  }

  /**
   * Inicializa el foreignProductsSelected igual foreignProductsSelected
   *
   * *Sets foreignProductsSelected  parameter equal to foreignProductsSelected*
   *
   * @param {LiveAbroadModel} foreignProductsSelected
   */
  setForeignSelected(foreignProductsSelected: LiveAbroadModel) {
    this.abreCuentasModel.foreignProductsSelected = foreignProductsSelected;
  }

  /**
   * Obtiene el parámetro de selectedShippingMethod
   *
   * *Gets selectedShippingMethod parameter*
   *
   * @returns {ObjectCheckModel} *this.abreCuentasModel.selectedShippingMethod
   */
  getselectedShippingMethod() {
    return this.abreCuentasModel.selectedShippingMethod;
  }

  /**
   * Inicializa el parámetro selectedShippingMethod igual selectedShippingMethod
   *
   * *Sets selectedShippingMethod  parameter equal to selectedShippingMethod*
   *
   * @param {ObjectCheckModel} selectedShippingMethod
   */
  setselectedShippingMethod(selectedShippingMethod: ObjectCheckModel) {
    this.abreCuentasModel.selectedShippingMethod = selectedShippingMethod;
  }

  /**
   * Obtiene la lista de cityList
   *
   * *Gets cityList list*
   *
   * @returns {any[]} this.abreCuentasModel.cityList
   */
  getCityList() {
    return this.abreCuentasModel.cityList;
  }

  /**
   * Inicializa el parámetro cityList igual cityList
   *
   * *Sets cityList  parameter equal to cityList*
   *
   * @param {any} cityList
   */
  setCityList(cityList: any) {
    this.abreCuentasModel.cityList = cityList;
  }

  /**
   * Obtiene el parámetro de ciiuModel seleccionado, actividad económica
   *
   * *Gets ciiuModel selected parameter, economical activity*
   *
   * @returns {CiiuModel} this.abreCuentasModel.ciiuModel
   */
  getCiiuSelected() {
    return this.abreCuentasModel.ciiuModel;
  }

  /**
   * Inicializa el parámetro ciiuModel seleccionado igual ciiuModel
   *
   * *Sets ciiuModel selected parameter equal to ciiuModel*
   *
   * @param {CiiuModel} ciiuModel
   */
  setCiiuSelected(ciiuModel: CiiuModel) {
    this.abreCuentasModel.ciiuModel = ciiuModel;
  }

  /**
   * Obtiene el parámetro de ciiuModel seleccionado, actividad económica Segundo titular
   *
   * *Gets ciiuModel selected parameter, economical activity Second Headline*
   *
   * @returns {CiiuSecondModel} this.abreCuentasModel.ciiuecondModel
   */
  getSecondCiiuSelected() {
    return this.abreCuentasModel.ciiuSecondModel;
  }
  /**
   * Inicializa el parámetro ciiuModel seleccionado igual ciiuModel
   *
   * *Sets ciiuModel selected parameter equal to ciiuModel*
   *
   * @param {CiiuSecondModel} ciiuModel
   */
  setSecondCiiuSelected(ciiuModel: CiiuSecondModel) {
    this.abreCuentasModel.ciiuSecondModel = ciiuModel;
  }
  /**
   * Obtiene el parámetro de ciiuDate
   * *Gets ciiuDate parameter*
   *
   * @returns {string} ciiuDate
   */
  getCiiuDate() {
    return this.abreCuentasModel.ciiuDate;
  }

  /**
   * Inicializa el parámetro ciiuDate igual ciiuDate
   *
   * *Sets ciiuDate  parameter equal to ciiuDate*
   *
   * @param {string} ciiuDate
   */
  setCiiuDate(ciiuDate: string) {
    this.abreCuentasModel.ciiuDate = ciiuDate;
  }
  /**
   * Obtiene el parámetro de ciiuDate
   * *Gets ciiuDate parameter*
   *
   * @returns {string} ciiuDate
   */
  getSecondCiiuDate() {
    return this.abreCuentasModel.ciiuSecondDate;
  }

  /**
   * Inicializa el parámetro ciiuDate igual ciiuDate
   *
   * *Sets ciiuDate  parameter equal to ciiuDate*
   *
   * @param {string} ciiuSecondDate
   */
  setSecondCiiuDate(ciiuDate: string) {
    this.abreCuentasModel.ciiuSecondDate = ciiuDate;
  }
  /**
   * Obtiene el parámetro de citySearchSelected
   *
   * *Gets citySearchSelected parameter*
   *
   * @returns {CityModel} citySearchSelected
   */
  getCitySearchSelected() {
    return this.abreCuentasModel.citySearchSelected;
  }

  /**
   * Inicializa el parámetro citySearchSelected igual citySearchSelected
   *
   * *Sets citySearchSelected  parameter equal to citySearchSelected*
   *
   * @param {CityModel} citySearchSelected
   */
  setCitySearchSelected(citySearchSelected: CityModel) {
    this.abreCuentasModel.citySearchSelected = citySearchSelected;
  }

  /**
   * Obtiene el parámetro de incomesOriginSearchSelected
   *
   * *Gets incomesOriginSearchSelected parameter*
   *
   * @returns {CityModel} this.abreCuentasModel.incomesOriginSearchSelected
   */
  getIncomesOriginSearchSelected() {
    return this.abreCuentasModel.incomesOriginSearchSelected;
  }

  /**
   * Inicializa el parámetro originSearchSelected igual originSearchSelected
   *
   * *Sets originSearchSelected  parameter equal to originSearchSelected*
   *
   * @param {IncomesOriginModel} originSearchSelected
   */
  setIncomesOriginSearchSelected(originSearchSelected: IncomesOriginModel) {
    this.abreCuentasModel.incomesOriginSearchSelected = originSearchSelected;
  }

  /**
   * Obtiene el parámetro de incomesOriginSecondHeadlineSelected
   *
   * *Gets incomesOriginSecondHeadlineSelected parameter*
   *
   * @returns {CityModel} this.abreCuentasModel.incomesOriginSecondHeadlineSelected
   */
  getIncomesOriginSecondHeadlineSearchSelected() {
    return this.abreCuentasModel.incomesOriginSecondHeadlineSelected;
  }

  /**
   * Inicializa el parámetro originSecondHeadlineSearchSelected igual originSecondHeadlineSearchSelected
   *
   * *Sets originSecondHeadlineSearchSelected  parameter equal to originSecondHeadlineSearchSelected*
   *
   * @param {IncomesOriginSecondHeadlineModel} originSecondHeadlineSearchSelected
   */
  setIncomesOriginSecondHeadlineSearchSelected(
    originSecondHeadlineSearchSelected: IncomesOriginSecondHeadlineModel,
  ) {
    this.abreCuentasModel.incomesOriginSecondHeadlineSelected =
      originSecondHeadlineSearchSelected;
  }

  /**
   * Obtiene el parámetro de agencySelected
   *
   * *Gets agencySelected parameter*
   *
   * @returns {AgencyModel} this.abreCuentasModel.agencySelected
   */
  getAgencySelected() {
    return this.abreCuentasModel.agencySelected;
  }

  /**
   * Inicializa el parámetro agencySelected igual agencySelected
   *
   * *Sets agencySelected  parameter equal to agencySelected*
   *
   * @param {AgencyModel} agencySelected
   */
  setAgencySelected(agencySelected: AgencyModel) {
    this.abreCuentasModel.agencySelected = agencySelected;
  }

  /**
   * Obtiene el parámetro de agencySelected
   *
   * *Gets agencySelected parameter*
   *
   * @returns {AgencyModel} this.abreCuentasModel.agencySelected
   */
  getDisbursementAgencySelected() {
    return this.abreCuentasModel.disbursementAgencySelected;
  }

  /**
   * Inicializa el parámetro agencySelected igual agencySelected
   *
   * *Sets agencySelected  parameter equal to agencySelected*
   *
   * @param {AgencyModel} agencySelected
   */
  setDisbursementAgencySelected(agencySelected: AgencyModel) {
    this.abreCuentasModel.disbursementAgencySelected = agencySelected;
  }

  /**
   * Obtiene el parámetro de checkboxInfoIncomesChecked
   *
   * *Gets checkboxInfoIncomesChecked parameter*
   *
   * @returns {CheckboxModel} this.abreCuentasModel.checkboxInfoIncomesChecked
   */
  getcheckboxInfoIncomesChecked() {
    return this.abreCuentasModel.checkboxInfoIncomesChecked;
  }

  /**
   * Inicializa el parámetro checkboxInfoIncomesChecked igual checkboxInfoIncomesChecked
   *
   * *Sets checkboxInfoIncomesChecked  parameter equal to checkboxInfoIncomesChecked*
   *
   * @param {CheckboxModel} checkboxInfoIncomesChecked
   */
  setcheckboxInfoIncomesChecked(checkboxInfoIncomesChecked: CheckboxModel) {
    this.abreCuentasModel.checkboxInfoIncomesChecked =
      checkboxInfoIncomesChecked;
  }

  /**
   * Obtiene el parámetro de infoInferredIncomes
   *
   * *Gets infoInferredIncomes parameter*
   *
   * @returns {any} this.abreCuentasModel.infoInferredIncomes
   */
  getinfoInferredIncomes() {
    return this.abreCuentasModel.infoInferredIncomes;
  }

  /**
   * Inicializa el parámetro infoInferredIncomes igual infoInferredIncomes
   *
   * *Sets infoInferredIncomes  parameter equal to infoInferredIncomes*
   *
   * @param {any} infoInferredIncomes
   */
  setinfoInferredIncomes(infoInferredIncomes: any) {
    this.abreCuentasModel.infoInferredIncomes = infoInferredIncomes;
  }

  getSegmentID() {
    return this.getPostlogin()
      ? this.getCustomerData().basic.sub_segment_id
      : this.getinfoInferredIncomes().segment_id;
  }

  /**
   * Obtiene el parámetro de infoIp
   * *Gets infoIp parameter*
   *
   * @returns {string} this.abreCuentasModel.infoIp
   */
  getinfoIp() {
    return this.abreCuentasModel.infoIp;
  }

  /**
   * Inicializa el parámetro infoIp igual infoIp
   *
   * *Sets infoIp  parameter equal to infoIp*
   *
   * @param {any} infoIp
   */
  setinfoIp(infoIp: any) {
    this.abreCuentasModel.infoIp = infoIp;
  }

  /**
   * Obtiene el parámetro de agreementSelected
   *
   * *Gets agreementSelected parameter*
   *
   * @returns {AgreementsModel} this.abreCuentasModel.agreementSelected
   */
  getAgreementSelected() {
    return this.abreCuentasModel.agreementSelected;
  }

  /**
   * Inicializa el parámetro agreementSelected igual agreementSelected
   *
   * *Sets agreementSelected  parameter equal to agreementSelected*
   *
   * @param {AgreementsModel} agreementSelected
   */
  setAgreementSelected(agreementSelected: AgreementsModel) {
    this.abreCuentasModel.agreementSelected = agreementSelected;
  }

  /**
   * Obtiene el parámetro de abreCuentasConfigs
   *
   * *Gets abreCuentasConfigs parameter*
   *
   * @returns {[id: string]} this.abreCuentasModel.abreCuentasConfigs
   */
  getAbreCuentasConfigs() {
    return this.abreCuentasModel.abreCuentasConfigs;
  }

  /**
   * Inicializa el parámetro abreCuentasConfigs igual abreCuentasConfigs
   *
   * *Sets abreCuentasConfigs  parameter equal to abreCuentasConfigs*
   *
   * @param {any} abreCuentasConfigs
   */
  setAbreCuentasConfigs(abreCuentasConfigs: any) {
    this.abreCuentasModel.abreCuentasConfigs = abreCuentasConfigs;
  }

  /**
   * Obtiene el parámetro de productSelected
   *
   * *Gets productSelected parameter*
   *
   * @returns {IProductsModel} this.abreCuentasModel.productSelected
   */
  getproductSelected() {
    return this.abreCuentasModel.productSelected;
  }

  /**
   * Inicializa el parámetro productSelected igual productSelected
   *
   * *Sets productSelected  parameter equal to productSelected*
   *
   * @param {any} productSelected
   */
  setproductSelected(productSelected: any) {
    this.abreCuentasModel.productSelected = productSelected;
  }

  /**
   * Inicializa el parámetro deviceInfo igual deviceInfo
   *
   * *Sets deviceInfo  parameter equal to deviceInfo*
   *
   * @param {LogDeviceModel} deviceInfo
   */
  setdeviceInfo(deviceInfo: LogDeviceModel) {
    this.abreCuentasModel.deviceInfo = deviceInfo;
  }

  /**
   * Obtiene el parámetro de deviceInfo
   *
   * *Gets deviceInfo parameter*
   *
   * @returns {LogDeviceModel} this.abreCuentasModel.deviceInfo
   */
  getdeviceInfo() {
    return this.abreCuentasModel.deviceInfo;
  }

  /**
   * Obtiene el parámetro de paydayProductModel
   *
   * *Gets paydayProductModel parameter*
   *
   * @returns {PayDayProductModel}  this.abreCuentasModel.paydayProductModel
   */
  getPayDayProductSelected(): PayDayProductModel {
    return this.abreCuentasModel.paydayProductModel;
  }

  /**
   * Inicializa el parámetro paydayProductModel igual paydayProductModel
   *
   * *Sets paydayProductModel  parameter equal to paydayProductModel*
   *
   * @param {PayDayProductModel} paydayProductModel
   */
  setPayDayProductSelected(paydayProductModel: PayDayProductModel) {
    this.abreCuentasModel.paydayProductModel = paydayProductModel;
  }
  /**
   * Se optienen el párametro de configValuesModel
   * @returns {ConfigValuesModel} this.abreCuentasModel.configValuesModel
   */
  getConfigurationValues() {
    return this.abreCuentasModel.configValuesModel;
  }
  /**
   * Inicializa el parámetro configValuesModel
   * @param {ConfigValuesModel} configValuesModel
   */
  setConfigurationValues(configValuesModel: ConfigValuesModel) {
    this.abreCuentasModel.configValuesModel = configValuesModel;
  }
  /**
   * Obtiene el parámetro de virtualCardfFranchiseModel
   *
   * *Gets VirtualCardFranchiseModel parameter*
   *
   * @returns {VirtualCardfranchiseModel}  this.abreCuentasModel.virtualCardFranchiseModel
   */
  getVirtualCardFranchise(): VirtualCardFranchiseModel {
    return this.abreCuentasModel.virtualCardFranchiseModel;
  }

  /**
   * Inicializa el parámetro virtualCardFranchiseModel igual virtualCardfranchiseModel
   *
   * *Sets virtualCardFranchiseModel  parameter equal to virtualCardFranchiseModel*
   *
   * @param {VirtualCardFranchiseModel} virtualCardFranchiseModel
   */
  setVirtualCardFranchise(
    virtualCardFranchiseModel: VirtualCardFranchiseModel,
  ) {
    this.abreCuentasModel.virtualCardFranchiseModel = virtualCardFranchiseModel;
  }

  /**
   * Obtiene el parámetro de contactAdressConfigTc
   *
   * *Gets contactAdressConfigTc parameter*
   *
   * @returns {AddressModel} this.abreCuentasModel.contactAdressConfigTc
   */
  getAddressInfoConfigTc() {
    return this.abreCuentasModel.contactAdressConfigTc;
  }

  /**
   * Inicializa el parámetro contactAdressConfigTc igual contactAdressConfigTc
   *
   * *Sets contactAdressConfigTc  parameter equal to contactAdressConfigTc*
   *
   * @param {AddressModel} contactAdressConfigTc
   */
  setAddressInfoConfigTc(contactAdressConfigTc: AddressModel) {
    this.abreCuentasModel.contactAdressConfigTc = contactAdressConfigTc;
  }
  setAmout(typeProduct, amount) {
    this.abreCuentasModel.pcoModel.granted_product_multi.forEach(product => {
      if (product.product_type === typeProduct) {
        product.limit_amount.amount = amount;
      }
    });
  }
  setEditProduct(typeProduct) {
    this.typeProduct = typeProduct;
  }
  getEditProduct() {
    return this.typeProduct;
  }
  getAmout(typeProduct) {
    let dataProduct = this.abreCuentasModel.pcoModel.granted_product_multi.find(
      product => product.product_type === typeProduct,
    );
    return dataProduct === undefined ? ' ' : dataProduct.limit_amount.amount;
  }
  /**
   * Obtiene el parámetro de contactAdressConfigTc
   * *Gets contactAdressConfigTc parameter*
   *
   * @returns {AddressModel} this.abreCuentasModel.contactAdressConfigTc
   */
  getAddtionalAddressConfigTcList() {
    return this.abreCuentasModel.addressTcConfigList;
  }

  /**
   * Inicializa el parámetro addressTcConfigListcon una lista de direcciones
   * *Sets contactAdressConfigTc  parameter eaual to address list*
   *
   * @param {AddressModel} addressTcConfigList
   */
  setAddtionalAddressConfigTcList(addtionalAddressConfigTcList: any[]) {
    this.abreCuentasModel.addressTcConfigList = addtionalAddressConfigTcList;
  }

  /**
   * Obtiene la lista de agreementList
   *
   * *Gets agreementList list*
   *
   * @returns {AgreementsModel[]} this.abreCuentasModel.agreementList
   */
  getAgreementList() {
    return this.abreCuentasModel.agreementList;
  }

  /**
   * Inicializa la lista agreementList igual agreementList
   *
   * *Sets agreementList  list equal to agreementList*
   *
   * @param {AgreementsModel[]} agreementList
   */
  setAgreementList(agreementList: AgreementsModel[]) {
    this.abreCuentasModel.agreementList = agreementList;
  }

  /**
   * Obtiene el parámetro de ProspectResponse
   *
   * *Gets ProspectResponse parameter*
   *
   * @returns {any} this.abreCuentasModel.ProspectResponse
   */
  getProspectResponse() {
    return this.abreCuentasModel.ProspectResponse;
  }

  /**
   * Inicializa el parámetro ProspectResponse igual ProspectResponse
   *
   * *Sets ProspectResponse  parameter equal to ProspectResponse*
   *
   * @param {any} ProspectResponse
   */
  setProspectResponse(ProspectResponse: any) {
    this.abreCuentasModel.ProspectResponse = ProspectResponse;
  }
  /**
   * Inicializa el parámetro ProspectResponseSecondHeadLine igual ProspectResponseSecondHeadLine
   *
   * *Sets ProspectResponseSecondHeadLine  parameter equal to ProspectResponseSecondHeadLine*
   *
   * @param {any} ProspectResponseSecondHeadLine
   */
  setProspectResponseSecondHeadLine(ProspectResponseSecondHeadLine: any) {
    this.abreCuentasModel.ProspectResponseSecondHeadLine =
      ProspectResponseSecondHeadLine;
  }

  /**
   * Obtiene el parámetro de ProspectResponse
   *
   * *Gets ProspectResponseSecondHeadLine parameter*
   *
   * @returns {any} this.abreCuentasModel.ProspectResponse
   */
  getProspectResponseSecondHeadLine() {
    return this.abreCuentasModel.ProspectResponseSecondHeadLine;
  }

  /**
   * Inicializa la lista benefitsList igual benefitsList
   *
   * *Sets benefitsList  list equal to benefitsList*
   *
   * @param {any} benefitsList
   */
  setBenefitsList(benefitsList: any) {
    this.abreCuentasModel.benefitsList = benefitsList;
  }

  /**
   * Obtiene la lista de benefitsList
   *
   * *Gets benefitsList list*
   *
   * @returns {string} this.abreCuentasModel.benefitsList
   */
  getBenefitsList() {
    return this.abreCuentasModel.benefitsList;
  }

  /**
   * Inicializa el parámetro customerData igual a customerData
   *
   * *Sets customerData parameter equal to customerData*
   *
   * @param {any} customerData
   */
  setCustomerData(customerData: any) {
    this.abreCuentasModel.customerData = customerData;
  }

  /**
   * Obtiene el parámetro de customerData
   *
   * *Gets customerData parameter*
   *
   * @returns {any} this.abreCuentasModel.customerData
   */
  getCustomerData() {
    return this.abreCuentasModel.customerData;
  }

  /**
   * Inicializa el parámetro pcoModel.granted_product.limit_amount.amount igual a amountPcoAproved
   *
   * *Sets pcoModel.granted_product.limit_amount.amount parameter equal to amountPcoAproved*
   *
   *  @param {number} amountPcoAproved
   */
  setAmountPcoAproved(amountPcoAproved: number) {
    this.abreCuentasModel.pcoModel.granted_product.limit_amount.amount =
      amountPcoAproved;
  }

  /**
   * Obtiene el parámetro de pcoModel.granted_product.limit_amount.amount
   *
   * *Gets pcoModel.granted_product.limit_amount.amount parameter*
   *
   * @returns {number} this.abreCuentasModel.pcoModel.granted_product.limit_amount.amount*
   */
  getAmountPcoAproved() {
    return this.abreCuentasModel.pcoModel.granted_product.limit_amount.amount;
  }

  /**
   * Obtiene el parámetro de pcoModel.granted_product_multi.limit_amount.amount
   *
   * *Gets pcoModel.granted_product_multi.limit_amount.amount parameter*
   *
   * @returns {number} this.abreCuentasModel.pcoModel.granted_product_multi.limit_amount.amount*
   */

  getAmountPcoProducType(productType: string) {
    let dataProduct =
      this.abreCuentasModel.pcoModelMulti[0].granted_product_multi.find(
        product => product.product_type === productType,
      );
    console.log('--getAmountPcoAprovedMulti-dataProduct', dataProduct);
    return dataProduct === undefined ? ' ' : dataProduct.product_type;
  }
  /**
   * Inicializa el parámetro simulatorModel igual a simulatorModel
   *
   * *Sets simulatorModel parameter equal to simulatorModel*
   *
   * @param {SimulatorModel} simulatorModel
   */
  setSimulatorModel(simulatorModel: SimulatorModel) {
    this.abreCuentasModel.simulatorModel = simulatorModel;
  }

  /**
   * Obtiene el parámetro de simulatorModel
   *
   * *Gets simulatorModel parameter*
   *
   * @returns {SimulatorModel} this.abreCuentasModel.simulatorModel
   */
  getSimulatorModel() {
    return this.abreCuentasModel.simulatorModel;
  }

  /**
   * Inicializa el parámetro loanModel igual a loanModel
   *
   * *Sets loanModel parameter equal to loanModel*
   *
   * @param {LoanModel} loanModel
   */
  setLoanModel(loanModel: LoanModel) {
    this.abreCuentasModel.loanModel = loanModel;
  }

  /**
   * Obtiene el parámetro de loanModel
   *
   * *Gets loanModel parameter*
   *
   * @returns {LoanModel} this.abreCuentasModel.loanModel
   */
  getLoanModel() {
    return this.abreCuentasModel.loanModel;
  }

  /**
   * Inicializa el parámetro pcoModeligual igual a pcoModel
   *
   * *Sets pcoModel parameter equal to pcoModel*
   *
   * @param {PcoModel} pcoModel
   */
  setPcoModel(pcoModel: PcoModel) {
    this.abreCuentasModel.pcoModel = pcoModel;
  }

  /**
   * Inicializa el parámetro pcoModelMulti igual igual a pcoModel[]
   *
   * *Sets pcoModelMulti parameter equal to pcoModel[]*
   *
   * @param {PcoModel} pcoModel
   */
  setPcoModelMulti(pcoModelMulti: PcoModel[]): void {
    this.abreCuentasModel.pcoModelMulti = pcoModelMulti;
  }

  /**
   * retorna el parámetro pcoModelMulti igual igual a pcoModel[]
   * @returns  {PcoModel} pcoModel
   */

  getPcoModelMulti() {
    return this.abreCuentasModel.pcoModelMulti; // return this.dataMockForPcoResponse.data[0];
  }

  /**
   * Obtiene el parámetro de pcoModel
   *
   * *Gets pcoModel parameter*
   *
   * @returns {PcoModel} this.abreCuentasModel.pcoModel
   */
  getPcoModel() {
    return this.abreCuentasModel.pcoModel;
  }

  /**
   * Determina si es zona gris o no
   *
   * *Gets grayZone status*
   *
   * @returns {boolean}
   */
  isGrayZone(): boolean {
    const solicitationStatus =
      this.abreCuentasModel.pcoModel.solicitation_status;
    if (solicitationStatus) {
      return (
        this.abreCuentasModel.pcoModel.solicitation_status.status_code ===
        'PCO03'
      );
    }
    return false;
  }

  /**
   * Inicializa el parámetro cardType igual a cardType
   *
   * *Sets cardType parameter equal to cardType*
   *
   *  @param {CardTypeModel} cardType
   */
  setCardTypeModel(cardType: CardTypeModel) {
    this.abreCuentasModel.cardType = cardType;
  }

  /**
   * Obtiene el parámetro de cardType
   *
   * *Gets cardType parameter*
   *
   * @returns {CardTypeModel} this.abreCuentasModel.cardType
   */
  getCardTypeModel() {
    return this.abreCuentasModel.cardType;
  }

  /**
   * Inicializa el parámetro cardTypes igual a cardTypes
   *
   * *Sets cardTypes parameter equal to cardTypes*
   *
   *  @param {} cardTypes
   */
  setCardTypesModel(cardTypes: {}) {
    this.abreCuentasModel.cardTypes = cardTypes;
  }

  /**
   * Obtiene el parámetro de cardTypes
   *
   * *Gets cardTypes parameter*
   *
   * @returns {} this.abreCuentasModel.cardTypes
   */
  getCardTypesModel() {
    return this.abreCuentasModel.cardTypes;
  }

  /**
   * Inicializa el parámetro productCard igual a productCard
   *
   * *Sets productCard parameter equal to productCard*
   *
   * @param {ProductCard} productCard
   */
  setProductCard(productCard: ProductCard) {
    this.abreCuentasModel.productCard = productCard;
  }

  /**
   * Obtiene el parámetro de productCard
   *
   * *Gets productCard parameter*
   *
   * @returns {ProductCard} this.abreCuentasModel.productCard
   */
  getProductCard() {
    return this.abreCuentasModel.productCard;
  }

  /**
   * Obtiene el parámetro de deviceInfoModel
   *
   * *Gets deviceInfoModel parameter*
   *
   * @returns {DeviceInfoModel} this.abreCuentasModel.deviceInfoModel
   */
  getDeviceInfo() {
    return this.abreCuentasModel.deviceInfoModel;
  }

  /**
   * Inicializa el parámetro deviceInfo igual a deviceInfo
   *
   * *Sets deviceInfo parameter equal to deviceInfo*
   *
   * @param {DeviceInfoModel} deviceInfo
   */
  setDeviceInfo(deviceInfo: DeviceInfoModel) {
    this.abreCuentasModel.deviceInfoModel = deviceInfo;
  }

  /**
   * Obtiene el parámetro de transactionInfoModel
   *
   * *Gets transactionInfoModel parameter*
   *
   * @returns {TransactionInfoModel} this.abreCuentasModel.transactionInfoModel
   */
  getTransactionInfo() {
    return this.abreCuentasModel.transactionInfoModel;
  }

  /**
   * Inicializa el parámetro transactionInfo igual a transactionInfo
   *
   * *Sets transactionInfo parameter equal to transactionInfo*
   *
   * @param {TransactionInfoModel} transactionInfo
   */
  setTransactionInfo(transactionInfo: TransactionInfoModel) {
    this.abreCuentasModel.transactionInfoModel = transactionInfo;
  }

  /**
   * Obtiene el parámetro de appInfo
   *
   * *Gets appInfo parameter*
   *
   * @returns {AppInfoModel} this.abreCuentasModel.appInfo
   */
  getAppInfo() {
    return this.abreCuentasModel.appInfo;
  }

  /**
   * Inicializa el parámetro appInfo igual a appInfo
   *
   * *Sets appInfo parameter equal to appInfo*
   *
   * @param {AppInfoModel} appInfo
   */
  setAppInfo(appInfo: AppInfoModel) {
    this.abreCuentasModel.appInfo = appInfo;
  }

  /**
   * Obtiene el parámetro de readCustomerService
   *
   * *Gets readCustomerService parameter*
   *
   * @returns {boolean} this.abreCuentasModel.readCustomerService
   */
  getReadCustomerService() {
    return this.abreCuentasModel.readCustomerService;
  }

  /**
   * Inicializa el parámetro readCustomerService igual a readCustomerService
   *
   * *Sets readCustomerService parameter equal to readCustomerService*
   *
   * @param {boolean} readCustomerService
   */
  setReadCustomerService(readCustomerService: boolean) {
    this.abreCuentasModel.readCustomerService = readCustomerService;
  }

  /**
   * Obtiene el parámetro de imageLottieError
   *
   * *Gets imageLottieError parameter*
   *
   * @returns {LottieImage} *this.abreCuentasModel.imageLottieError*
   */
  getImageLottieError() {
    return this.abreCuentasModel.imageLottieError;
  }

  /**
   * Inicializa el parámetro imageLottieError igual a imageLottieError
   *
   * *Sets imageLottieError parameter equal to imageLottieError*
   *
   * @param {LottieImage} imageLottieError
   */
  setImageLottieError(imageLottieError: LottieImage) {
    this.abreCuentasModel.imageLottieError = imageLottieError;
  }

  /**
   * Inicializa el parámetro registerBytteLicensePromise igual a promise
   *
   * *Sets registerBytteLicensePromise parameter equal to promise*
   *
   *  @param {Promise<any>} promise
   */
  setRegisterBytteLicensePromise(promise: Promise<any>) {
    this.registerBytteLicensePromise = promise;
  }

  /**
   * Obtiene el parámetro de registerBytteLicensePromise
   *
   * *Gets registerBytteLicensePromise parameter*
   *
   * @returns {Promise<any>} this.registerBytteLicensePromise
   */
  getRegisterBytteLicensePromise() {
    return this.registerBytteLicensePromise;
  }

  /**
   * Verifica si la variable str es vacia
   *
   * *Verify that str variable is empty*
   *
   * @param {string} str
   * @returns {boolean} true or false
   */
  isEmpty(str: string): boolean {
    return !str || str.trim().length === 0;
  }

  /**
   * Obtiene el parámetro de showMessageUpdate
   *
   * *Gets showMessageUpdate parameter*
   *
   * @returns {boolean} this.abreCuentasModel.showMessageUpdate
   */
  getShowMessageUpdate() {
    return this.abreCuentasModel.showMessageUpdate;
  }

  /**
   * Inicializa el parámetro showMessageUpdate igual a showMessageUpdate
   *
   * *Sets showMessageUpdate parameter equal to showMessageUpdate*
   *
   * @param {boolean} showMessageUpdate
   */
  setShowMessageUpdate(showMessageUpdate: boolean) {
    this.abreCuentasModel.showMessageUpdate = showMessageUpdate;
  }

  /**
   * Obtiene el parámetro de updateClient
   *
   * *Gets updateClient parameter*
   *
   * @returns {boolean} this.abreCuentasModel.updateClient
   */
  getUpdateClient() {
    return this.abreCuentasModel.updateClient;
  }

  /**
   * Inicializa el parámetro updateClient igual a updateClient
   *
   * *Sets updateClient parameter equal to updateClient*
   *
   * @param {boolean} updateClient
   */
  setUpdateClient(updateClient: boolean) {
    this.abreCuentasModel.updateClient = updateClient;
  }

  /**
   * Obtiene el parámetro de devicePermissions
   *
   * *Gets devicePermissions parameter*
   *
   * @returns {string} *this.devicePermissions*
   */
  getDevicePermissions() {
    return this.devicePermissions;
  }

  /**
   * Inicializa el parámetro this.devicePermissions igual a permissions
   *
   * *Sets this.devicePermissions parameter equal to permissions*
   *
   * @param {string} permissions
   */
  setDevicePermissions(permissions: string) {
    this.devicePermissions = permissions;
  }

  /**
   * Inicializa el parámetro this.geoLocalization igual a location
   *
   * *Sets this.geoLocalization parameter equal to location*
   *
   *  @param {string} location
   */
  setGeoLocation(location: string) {
    this.geoLocalization = location;
  }

  /**
   * Obtiene el parámetro de geoLocalization
   *
   * *Gets geoLocalization parameter*
   *
   * @returns {string} *this.geoLocalization*
   */
  getGeoLocation() {
    return this.geoLocalization;
  }

  /**
   * Realiza la conversión de una cadena de texto a PascalCase
   *
   * *Coverts a string to PascalCase*
   *
   * @param {string} word
   * @returns string word in PascalCase
   */
  converttoPascalCase(word: string) {
    if (word.split(' ').length > 1) {
      const newWord = word.split(' ');
      let finalWord = '';
      newWord.forEach(separate_word => {
        finalWord +=
          separate_word.charAt(0).toUpperCase() +
          separate_word.substr(1).toLowerCase() +
          ' ';
      });
      return finalWord.trim();
    }
    return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
  }

  /**
   * Realiza la conversión de una imagen a un DataUrl por medio de Canvas
   *
   * *Coverts an image to DataUrl via Canvas*
   *
   * @param {any} url
   * @param {any} outputFormat
   *
   * @returns An image in DataUrl format
   */
  convertToDataURLviaCanvas(url: any, outputFormat: any) {
    return new Promise((resolve, _reject) => {
      const img = new Image();
      img.crossOrigin = '*';
      img.onload = () => {
        const canvas = document.createElement('CANVAS') as HTMLCanvasElement;
        const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
        let dataURL;
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);
        resolve(dataURL);
      };
      img.src = url;
    });
  }

  /**
   * Procesa una imagen en Base64
   *
   * *Proccess an image in Base64 form*
   *
   * @param {string} data_img
   * @returns An image in Base64 form
   */
  proccessBase64(data_img: string) {
    return data_img.split(',')[1];
  }

  /**
   * Normaliza una cadena de texto
   *
   * *Normalize a string*
   *
   * @param {string} input
   * @returns {string} Normalized text
   */

  normalize(input: string): string {
    return input
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ /g, '')
      .toLowerCase()
      .trim();
  }

  /**
   * Busca una ciudad por los parámetros name, province_code o list
   *
   * *Search a city by name, province_code or list parameters*
   *
   * @param {string} name
   * @param {number} province_code
   * @param {CityModelAlt[]} list
   *
   * @returns {CityModelAlt} City
   */
  filterCity(
    name: string,
    province_code: number,
    list: CityModelAlt[],
  ): CityModelAlt {
    return list.filter((element: CityModelAlt, _index, _array) => {
      return (
        element.province_code === province_code &&
        this.normalize(element.description.split(',')[0]) ===
        this.normalize(name)
      );
    })[0];
  }

  /**
   * Obtiene el parámetro que debe ser buscado en la consulta de acuerdo a los parámetros name y url
   *
   * *Gets de parameter that must be part of the query from name and url parameters*
   *
   * @param {string} name
   * @param {string} url
   * @returns {string} Result of Query Param By Name
   */
  getQueryParamByName(name: string, url: string): string {
    const search = url.substring(1);
    const params = search.split('&');
    let result = '';

    for (const param of params) {
      const newParam = param.split('=');
      const paramName = newParam[0];
      const paramValue = newParam[1];
      if (paramName === name && paramValue && paramValue.trim().length > 0) {
        result = paramValue;
      }
    }

    return result;
  }

  /**
   * Inicializa el parámetro receiveCard igual a elementId
   *
   * *Sets receiveCard parameter equal to elementId*
   *
   * @param {string} elementId
   */
  setReceiveCard(elementId: string) {
    this.abreCuentasModel.receiveCard = elementId;
  }

  /**
   * Control para el evento volver de add loan
   *
   * controls for the back evento in add loan
   *
   * @param {boolean} back
   */
  setDidBackAddLoan(back: boolean) {
    this.didBackAddLoan = back;
  }

  getDidBackAddLoan() {
    return this.didBackAddLoan;
  }
  /**
   * Obtiene el parámetro de receiveCard
   *
   * *Gets receiveCard parameter*
   *
   * @returns {string} this.abreCuentasModel.receiveCard
   */
  getReceiveCard() {
    return this.abreCuentasModel.receiveCard;
  }

  /**
   * Inicializa el parámetro updateMail igual a elementId
   *
   * *Sets updateMail parameter equal to elementId*
   *
   * @param {boolean} elementId
   */
  setUpdatingMail(elementId: boolean) {
    this.abreCuentasModel.updateMail = elementId;
  }

  /**
   * Obtiene el parámetro de updateMail
   *
   * *Gets updateMail parameter*
   *
   * @returns {boolean} this.abreCuentasModel.updateMail
   */
  getUpdatingMail(): boolean {
    return this.abreCuentasModel.updateMail;
  }

  /**
   * Inicializa el parámetro updatePhone igual a elementId
   *
   * *Sets updatePhone parameter equal to elementId*
   *
   * @param {boolean} elementId
   */
  setUpdatingPhone(elementId: boolean) {
    this.abreCuentasModel.updatePhone = elementId;
  }

  /**
   * Obtiene el parámetro de updatePhone
   *
   * *Gets updatePhone parameter*
   *
   * @returns {boolean} this.abreCuentasModel.updatePhone
   */
  getUpdatingPhone(): boolean {
    return this.abreCuentasModel.updatePhone;
  }

  /**
   * Inicializa el parámetro updatePhone igual a elementId
   *
   * *Sets updatePhone parameter equal to elementId*
   *
   * @param {boolean} elementId
   */
  setPayDay(day: string) {
    this.abreCuentasModel.payDay = day;
  }

  /**
   * Obtiene el parámetro de productSelected
   *
   * *Gets productSelected parameter*
   *
   * @returns {IProductsModel} this.abreCuentasModel.productSelected
   */
  getcreateProductSelected() {
    return this.abreCuentasModel.createProduct;
  }

  /**
   * Inicializa el parámetro productSelected igual productSelected
   *
   * *Sets productSelected  parameter equal to productSelected*
   *
   * @param {any} productSelected
   */
  setcreateProductSelected(createProduct: any) {
    this.abreCuentasModel.createProduct = createProduct;
  }

  /**
   * Obtiene el parámetro de updatePhone
   *
   * *Gets updatePhone parameter*
   *
   * @returns {string} this.abreCuentasModel.updatePhone
   */
  getPAyDay(reverseDate?: boolean): string | null {
    const returnDate = this.abreCuentasModel.payDay;
    if (returnDate != null) {
      return reverseDate
        ? returnDate.split('/').reverse().join('-')
        : returnDate;
    }
    return null;
  }

  setAdvisorCode(code: string) {
    this.abreCuentasModel.advisorCode = code;
  }

  getAdvisorCode(): string | null {
    return this.abreCuentasModel.advisorCode;
  }

  setAdvisorCheck(elementId: string) {
    this.abreCuentasModel.advisorCheck = elementId;
  }

  getAdvisorCheck() {
    return this.abreCuentasModel.advisorCheck;
  }

  /**
   * Summary Get Flow Structure.
   */
  getFlowStructure() {
    return this.abreCuentasModel.flowStructure;
  }

  /**
   * Summary Set Flow Structure.
   */
  setFlowStructure(flows: any[]) {
    let multiFlowStrcuture = this.getMultiproductFlowUpdate();
    let listProductsSelected = this.getProductsSelects();
    let phase = {};
    this.abreCuentasModel.flowStructure = flows;
  }

  setStructureMultiToCurrentFlow(multiFlowStrcuture) {
    if (
      multiFlowStrcuture['start'] !== undefined &&
      multiFlowStrcuture['start'] !== null
    ) {
      this.abreCuentasModel.flowStructure[0].flows.multiProduct.startPhase =
        multiFlowStrcuture['start'];
    }

    Object.keys({ ...multiFlowStrcuture['phases'] }).map(namePhase => {
      // validamos si la fase tiene algo en la llave start
      if (
        multiFlowStrcuture['phases'][namePhase].start !== undefined &&
        multiFlowStrcuture['phases'][namePhase].start !== ''
      ) {
        let newObjPhase = {};

        // validamos que el flujo de multi tenga fases
        if (
          this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases !==
          undefined &&
          Object.keys(
            this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases,
          ).length > 0
        ) {
          // cambiamos el valor de la llave start de la fase.
          this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[
            namePhase
          ].start = multiFlowStrcuture['phases'][namePhase].start;
        } else {
          newObjPhase[namePhase] = multiFlowStrcuture['phases'][namePhase];

          // agragamos la fase al flujo de multi
          this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases =
            newObjPhase;
        }
      }

      // validamos que la fase puesta en el archivo tenga pasos/steps
      if (
        multiFlowStrcuture['phases'][namePhase].steps !== undefined &&
        Object.keys(multiFlowStrcuture['phases'][namePhase].steps).length > 0
      ) {
        // recorremos los steps puesto en el archivo de multiproducto
        Object.keys(multiFlowStrcuture['phases'][namePhase].steps).map(
          nameStep => {
            let newObj = {};

            // validamos que el paso/step exista en multiproducto
            if (
              this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[
                namePhase
              ].steps[nameStep] !== undefined
            ) {
              this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[
                namePhase
              ].steps[nameStep] = Object.assign(
                this.abreCuentasModel.flowStructure[0].flows.multiProduct
                  .phases[namePhase].steps[nameStep],
                multiFlowStrcuture['phases'][namePhase].steps[nameStep],
              );
            } else {
              newObj[nameStep] =
                multiFlowStrcuture['phases'][namePhase].steps[nameStep];

              // agregamos el paso/step completo al flujo de multiproducto
              this.abreCuentasModel.flowStructure[0].flows.multiProduct.phases[
                namePhase
              ].steps = Object.assign(
                {
                  ...this.abreCuentasModel.flowStructure[0].flows.multiProduct
                    .phases[namePhase].steps,
                },
                newObj,
              );
            }
          },
        );
      }
    });
  }

  setMultiproductFlowUpdate(dataFlowUpdate: {}) {
    this.abreCuentasModel.multiproductFlowUpdate = dataFlowUpdate;
  }

  getMultiproductFlowUpdate() {
    return this.abreCuentasModel.multiproductFlowUpdate;
  }

  getMultiflowStructurePhases(phases: any) {
    return this.abreCuentasModel.flowStructure[0].flows[phases].phases;
  }
  /**
   * Se indica si el lciente existente tiene o no algún producto activo
   *
   *
   * @param {DocumentModel} model
   */
  setClientProduct(isclientProduct: boolean) {
    this.abreCuentasModel.isclientProduct = isclientProduct;
  }

  /**
   * Obtenego un booleano donde me indica si el cliente tiene o no un producto
   *
   * *Gets documentModel parameter*
   *
   */
  getClientProduct() {
    return this.abreCuentasModel.isclientProduct;
  }

  /**
   * Se indica si el lciente existente tiene o no algún producto activo
   *
   *
   * @param {DocumentModel} model
   */
  setListClientProduct(listclientProduct: [any]) {
    this.abreCuentasModel.listclientProduct = listclientProduct;
  }

  /**
   * Obtenego un booleano donde me indica si el cliente tiene o no un producto
   *
   * *Gets documentModel parameter*
   *
   */
  getListClientProduct() {
    return this.abreCuentasModel.listclientProduct;
  }

  setAppLoaded(value: boolean) {
    this.abreCuentasModel.appLoaded = value;
  }

  getAppLoaded() {
    return this.abreCuentasModel.appLoaded;
  }

  setIsPortal(value: boolean) {
    this.abreCuentasModel.isPortal = value;
  }

  getIsPortal() {
    return this.abreCuentasModel.isPortal;
  }

  setIsNewClient(status: boolean) {
    this.isNewClient = status;
  }

  getIsNewClient(): boolean {
    return this.isNewClient;
  }

  setCSID(id: string) {
    return (this.abreCuentasModel.CSID = id);
  }

  /**
   * Obtener transaction_id
   *
   * *Gets transaction_id*
   *
   * @returns {string} this.abreCuentasModel.transaction_id
   */
  getCSID() {
    return this.abreCuentasModel.CSID;
  }

  setPPID(id: string) {
    return (this.abreCuentasModel.PPID = id);
  }

  getPPID() {
    return this.abreCuentasModel.PPID;
  }

  setIp(ip: string) {
    return (this.abreCuentasModel.ipAddress = ip);
  }

  /**
   * Obtener ipAddress
   *
   * *Gets ipAddress*
   *
   * @returns {string} this.abreCuentasModel.ipAddress
   */
  getIp() {
    return this.abreCuentasModel.ipAddress;
  }

  setOtherSimulationData(value?: any) {
    this.abreCuentasModel.otherSimulationData = value;
  }

  getOtherSimulationData() {
    return this.abreCuentasModel.otherSimulationData;
  }

  getOtherEvidentenData() {
    return this.abreCuentasModel.otherEvidenteDataModel;
  }
  setOtherEvidentenData(value?: any) {
    console.warn('evidente--', value);
    this.setDocumentInfo(value);
    this.setProspectResponse({
      client: value.client === undefined ? false : value.client,
    });
    this.setPostlogin(value.client);
    if (this.viewOptionMultiProduct) {
      const contactInfo = value;
      let dataContact = new ContactModel();
      dataContact.email = contactInfo.email;
      dataContact.mobile_number = contactInfo.mobile_number;
      this.setContactInfo(dataContact);
    }
    // this.abreCuentasModel.otherSimulationData = value;
  }

  /**
   * setear productos flujo multiproducto
   * @param data array de productos
   */
  setProductsSelects(data: any[]) {
    this.productSelect = data.sort((a, b) => {
      return a.prioritizeForClient - b.prioritizeForClient;
    });
  }

  /**
   * @returns products seleccionado
   */
  getProductsSelects() {
    return this.productSelect;
  }

  /**
   * setear de viewOptionMultiProduct
   */
  setMultiView(status: boolean) {
    this.viewOptionMultiProduct = status;
  }

  setIsNormalizacion(status: boolean) {
    this.isNormalizacion = status;
  }

  getIsNormalizacion() {
    return this.isNormalizacion;
  }

  /**
   * setear de isCardDuality
   */
  setCarduality(status: boolean) {
    this.isCardDuality = status;
  }

  getCarduality() {
    return this.isCardDuality;
  }
  /**
   * setear de haveLoan
   */
  setHaveloan(status: boolean) {
    this.haveLoan = status;
  }

  setSaveValueInputAmount(savevalue: any) {
    this.abreCuentasModel.savevaluemodel.savevaluemodel = savevalue;
  }

  getSaveValueInputAmount() {
    return this.abreCuentasModel.savevaluemodel.savevaluemodel;
  }
  setSaveValuePlazoMonto(termAmount: any) {
    this.inputTermAmount = termAmount;
  }

  getSaveValuePlazoMonto() {
    return this.inputTermAmount;
  }
  setcontractType(contractType: any) {
    this.contractTypemodel = contractType;
  }
  getcontractType() {
    return 'type_of_contract' + this.contractTypemodel;
  }
  setDisbursementConfiguration(DisbursementConfiguration: any) {
    this.DisbursementConfigurationModel = DisbursementConfiguration;
  }

  getDisbursementConfiguration() {
    return this.DisbursementConfigurationModel;
  }

  getAgreementDetailSelected() {
    return this.abreCuentasModel.agreementDetail.agreement;
  }

  setAgreementDetailSelected(agreementDetail: DetailAgreement) {
    this.abreCuentasModel.agreementDetail = agreementDetail;
  }

  getRequestLoanSelected() {
    return this.abreCuentasModel.selectLoan;
  }

  setRequestLoanSelected(selected: any) {
    this.abreCuentasModel.selectLoan = selected;
  }
  /**
   * Obtener modelo de solicitud
   *
   * *Gets requestModel*
   *
   * @returns {requestModel} requestModel
   */
  getRequestModel(): any {
    return this.requestModel;
  }

  /**
   * Setear el modelo de solicitud
   *
   * *Sets requestModel*
   *
   * @param {AbreCuentrequestModelasModel} requestModel
   */
  setRequestModel(requestModel: any) {
    this.requestModel = requestModel;
  }
  getOfficeStatus() {
    return this.checkDisbursement;
  }

  setOfficeStatus(status: boolean) {
    this.checkDisbursement = status;
  }

  setCreditSelection(creditSelection: any) {
    this.creditSelection = creditSelection;
  }

  getCreditSelection() {
    return this.creditSelection;
  }

  setOutlaySelection(outlaySelection: any) {
    this.outlaySelection = outlaySelection;
  }

  getOutlaySelection() {
    return this.outlaySelection;
  }

  getFlowLoan() {
    return (
      this.getProductsSelects().filter(
        fil => fil.flow === BUSINESS_CONST.PRODUCT_TYPE_LOAN,
      ).length > 0
    );
  }

  getFlowTCR() {
    return (
      this.getProductsSelects().filter(
        fil => fil.flow === BUSINESS_CONST.PRODUCT_TYPE_TC,
      ).length > 0
    );
  }

  getFlowRotativo() {
    return (
      this.getProductsSelects().filter(
        fil => fil.flow === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING,
      ).length > 0
    );
  }

  getFlowCP() {
    return (
      this.getProductsSelects().filter(
        fil => fil.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE,
      ).length > 0
    );
  }

  setFormLoan(formLoan: any) {
    this.formLoan = formLoan;
  }

  getFormLoan() {
    return this.formLoan;
  }

  setCreditIndex(creditIndex: number) {
    this.creditIndex = creditIndex;
  }

  getCreditIndex() {
    return this.creditIndex;
  }

  setEditCredit(editCredit: boolean) {
    this.editCredit = editCredit;
  }

  getEditCredit() {
    return this.editCredit;
  }

  setCreditInfo(creditInfo: any) {
    this.creditInfo = creditInfo;
  }

  setDeleteCredit(deleteCredit: boolean) {
    this.deleteCredit = deleteCredit;
  }

  getDeleteCredit() {
    return this.deleteCredit;
  }

  getCreditInfo() {
    return this.creditInfo;
  }

  setCreditList(creditList: any) {
    this.creditList = creditList;
  }

  getCreditList() {
    return this.creditList;
  }

  setDisbursementInfo(disbursementInfo: any) {
    this.disbursementInfo = disbursementInfo;
  }

  setSavedOtherBank(otherBankInfo: any) {
    this.otherBankAccount = otherBankInfo;
  }

  getSavedOtherBank() {
    return this.otherBankAccount;
  }

  getDisbursementInfo() {
    return this.disbursementInfo;
  }

  setStatusCreate(status: any) {
    this.statuscreateaccount = status;
  }

  getStatusCreate() {
    return this.statuscreateaccount;
  }
  getLoanSelected() {
    const products = this.getProductsSelects();
    const haveLoan = products.filter(
      product => product.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN,
    );
    return haveLoan.length === 1 ? true : false;
  }

  setPageZoneGray(flow: string) {
    this.flowPageZoneGray = flow;
  }

  getPageZoneGray() {
    return this.flowPageZoneGray;
  }

  setRatesLoan(rates: string) {
    this.ratesLoan = rates;
  }

  getRatesLoan() {
    return this.ratesLoan;
  }
  /**
   * Obtener modelo de solicitudes de cliente
   *
   * *Gets customerRequests*
   *
   * @returns {any} customerRequests
   */
  getCustomerRequests(): any {
    return this.customerRequests;
  }

  /**
   * Setear el modelo de solicitudes de cliente
   *
   * *Sets customerRequests*
   *
   * @param {any} customerRequests
   */
  setCustomerRequests(customerRequests: any) {
    this.customerRequests = customerRequests;
  }

  /**
   * Obtener modelo de solicitud
   *
   * *Gets requestModel*
   *
   * @returns {requestModel} requestModel
   */
  getDocumentsUploaded(): any {
    return this.documentsUploaded;
  }

  /**
   * Setear el modelo de solicitud
   *
   * *Sets requestModel*
   *
   * @param {AbreCuentrequestModelasModel} requestModel
   */
  setDocumentsUploaded(documentsUploaded: boolean) {
    this.documentsUploaded = documentsUploaded;
  }

  setProductsMax(products: any) {
    this.maxproducts = products;
  }

  getProductsMax() {
    return this.maxproducts;
  }

  setDocumentarySufficiencyList(documentarySufficiencyList: any[]) {
    this.documentarySufficiencyList = documentarySufficiencyList;
  }

  getDocumentarySufficiencyList() {
    return this.documentarySufficiencyList;
  }

  setDataMFE(infoClient: any) {
    console.log('infoClient', infoClient);
    this.setCustomerData(infoClient);
  }

  setProductsVincu(product: string) {
    this.productsSelectVicul.push(product);
  }

  setPriorization(priorization: any) {
    this.priorization = priorization;
  }

  getPriorization() {
    return this.priorization;
  }

  setInsurability(isInsurability: boolean) {
    this.isInsurability = isInsurability;
  }

  getInsurability() {
    return this.isInsurability;
  }

  setListIsPEP(pep: string) {
    this.pep = pep;
  }

  getListIsPEP() {
    return this.pep;
  }

  setAllyCode(code: string) {
    console.log('code', code);
    this.code_ally = code;
  }

  getAllyCode(): string {
    console.log('this.code_ally', this.code_ally);
    return this.code_ally;
  }
  setRateAlly(allyRate: any): any {
    // tslint:disable-next-line:no-unused-expression
    this.rate_ally = allyRate;
  }

  getRateAlly(): any {
    console.log('this.rate_ally', this.rate_ally);

    return this.rate_ally;
  }
  setflagGreyZone(flag: boolean) {
    this.flagGreyZone = flag;
  }
  getflagGreyZone() {
    return this.flagGreyZone;
  }

  setSeller(data: any) {
    this.seller = data;
  }
  getSeller(): any {
    return this.seller;
  }
  setSellerMarca(data: any) {
    this.sellerboolean = data;
  }
  getSellerMarca() {
    return this.sellerboolean;
  }

  setRequestEntity(data: any) {
    this.RequestEntityOp = data;
  }
  getRequestEntity() {
    return this.RequestEntityOp;
  }
  setRatesOffer(rates: any) {
    this.rates = rates;
  }

  getRatesOffer() {
    return this.rates;
  }

  getPassScreenCity() {
    return this.PassScreenCity;
  }

  setPassScreenCity(value: string) {
    this.PassScreenCity = value;
  }

  filterCountryListxName(data: string) {
    let country_list = this.parametersService.getSetting(OpEnum.COUNTRY_LIST);
    return country_list.find(
      item => item.description.toLocaleLowerCase() === data.toLocaleLowerCase(),
    );
  }

  getAssociateRevolving() {
    return this.associate_revolving;
  }
  setAssociateRevolving(createProduct: any) {
    this.associate_revolving = createProduct;
  }

  getAssociateCopyRevolving() {
    return this.associate_copy_revolving;
  }

  setAssociateCopyRevolving(createProduct: any) {
    this.associate_copy_revolving = createProduct;
  }
  setvalidate(validate: any) {
    this.validate = validate;
  }

  getvalidate() {
    return this.validate;
  }
  getWasDeleteLoan() {
    return this.wasDeleteLoan;
  }

  setWasDeleteLoan(value: boolean) {
    this.wasDeleteLoan = value;
  }

  setParametrizedHeaders(parametrizedHeaders: HttpHeaders | undefined): void {
    this.parametrizedHeaders = parametrizedHeaders;
  }

  setRescueData(rescueData: IRescueData) {
    this.rescueData = rescueData;
  }

  getRescueData() {
    return this.rescueData;
  }

  rescueDataIsEmpty() {
    return this.rescueData === undefined ? true : false;
  }

  getPhase() {
    return this.phase;
  }

  setPhase(value) {
    switch (value) {
      case 'identification':
        value = 'identification';
        break;
      case 'client-data-update-tc':
        value = 'captura';
        break;
      case 'configuration':
        value = 'configuration';
        break;
      case 'sign-on':
        value = 'vinculacion';
        break;
      default:
        break;
    }
    console.log('🚀 ~ file: abre-cuentas.service.ts:4020 ~ AbreCuentasService ~ setPhase ~ value:', value);
    this.phase = value;
  }
  /**
   * setear valor booleano de si el error fue 01-04
   */
  setIsErrorPco(isErrorPco: boolean) {
    this.isErrorPco = isErrorPco;
  }
  /**
   * obtener valor booleano de si el error fue 01-04
   */
  getIsErrorPco() {
    return this.isErrorPco;
  }

  setDistricts(districtOptions: any) {
    this.districtOptions = districtOptions;
  }

  getDistricts() {
    return this.districtOptions;
  }

  getUserJemelii() {
    return this.userJemelii;
  }

  setUserJemelii(userJemelii: boolean) {
    this.userJemelii = userJemelii;
  }
}
